/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Reporters
 * OpenAPI spec version: 0.1.0
 */
import axios from 'axios'
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { useMutation, useQuery } from 'react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query'
export type CourtReporterEventsParams = {
  since: string
  until: string
}

export type ListAvailabilitiesParams = {
  since: string
  until: string
}

export type EndEventParams = {
  end_related_events?: boolean
}

export type RemoveEventBookingParams = {
  unbook_related_events?: boolean
}

export type BookEventParams = {
  book_related_events?: boolean
}

export type GetEventParticipantsParams = {
  excluded_ids?: string[]
}

export type PresignIdScreenshotUploadParams = {
  content_type: string
}

export type PresignCertificateUploadParams = {
  content_type: string
}

export type PresignCommissionLicenseUploadParams = {
  content_type: string
}

export type ReporterWeeklyAvailabilityParams = {
  week_start: string
}

export type CalendarEventsParams = {
  since: string
  until: string
}

export type EventsParams = {
  since: string
  until: string
}

export type CalendarAdminCourtReporterEventsParams = {
  since: string
  until: string
}

export type CalendarAdminEventsParams = {
  since: string
  until: string
}

export type AdminEventsParams = {
  since: string
  until: string
}

export type ZoomParticipantPhoneNumber = string | null

export type ZoomParticipantParticipantUserId = string | null

export type ZoomParticipantEmail = string | null

export type ZoomParticipant = {
  created_at: string
  email?: ZoomParticipantEmail
  id: string
  join_time: string
  meeting_instance_id: string
  participant_user_id?: ZoomParticipantParticipantUserId
  phone_number?: ZoomParticipantPhoneNumber
  user_id: string
  user_name: string
}

export type WitnessEventRecording = {
  client_status: string
  status: string
}

export type WeeklyAvailabilityLastUpdatedBy = ChangedBy | null

export type WeeklyAvailabilityLastUpdatedAt = string | null

export type WeeklyAvailability = {
  is_read_only: boolean
  last_updated_at?: WeeklyAvailabilityLastUpdatedAt
  last_updated_by?: WeeklyAvailabilityLastUpdatedBy
  ranges?: AvailabilityRange[]
  reporter_id: string
  timezone: string
  week_start: string
}

export type ValidationErrorLocItem = string | number

export type ValidationError = {
  loc: ValidationErrorLocItem[]
  msg: string
  type: string
}

export type User = {
  id: string
  priority_client: boolean
}

export type UploadedFileUrl = string | null

export type UploadedFile = {
  key: string
  original_file_name: string
  url?: UploadedFileUrl
}

export type UpdateZoombotStatusStatus =
  (typeof UpdateZoombotStatusStatus)[keyof typeof UpdateZoombotStatusStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateZoombotStatusStatus = {
  resume_recording: 'resume_recording',
  pause_recording: 'pause_recording',
} as const

export type UpdateZoombotStatus = {
  status: UpdateZoombotStatusStatus
}

export type UpdateStripeAccountTimezone = string | null

export type UpdateStripeAccountState = string | null

export type UpdateStripeAccountPhoneNumber = string | null

export type UpdateStripeAccountName = string | null

export type UpdateStripeAccountEmail = string | null

export type UpdateStripeAccountCounty = string | null

export type UpdateStripeAccountCommissionNumber = string | null

export type UpdateStripeAccountCommissionExpiry = string | null

export type UpdateStripeAccount = {
  certificates?: UploadedFile[]
  commission_expiry?: UpdateStripeAccountCommissionExpiry
  commission_licenses?: UploadedFile[]
  commission_number?: UpdateStripeAccountCommissionNumber
  county?: UpdateStripeAccountCounty
  email?: UpdateStripeAccountEmail
  name?: UpdateStripeAccountName
  phone_number?: UpdateStripeAccountPhoneNumber
  state?: UpdateStripeAccountState
  stripe_account_id: string
  timezone?: UpdateStripeAccountTimezone
}

export type UpdateReporterInputTimezone = string | null

export type UpdateReporterInputStripeAccountId = string | null

export type UpdateReporterInputState = string | null

export type UpdateReporterInputPhoneNumber = string | null

export type UpdateReporterInputCounty = string | null

export type UpdateReporterInputCommissionNumber = string | null

export type UpdateReporterInputCommissionExpiry = string | null

export type UpdateReporterInput = {
  certificates?: UploadedFile[]
  commission_expiry?: UpdateReporterInputCommissionExpiry
  commission_licenses?: UploadedFile[]
  commission_number?: UpdateReporterInputCommissionNumber
  county?: UpdateReporterInputCounty
  email: string
  name: string
  phone_number?: UpdateReporterInputPhoneNumber
  state?: UpdateReporterInputState
  stripe_account_id?: UpdateReporterInputStripeAccountId
  timezone?: UpdateReporterInputTimezone
}

export type UpdateLevelTimezone = string | null

export type UpdateLevelStripeAccountId = string | null

export type UpdateLevelState = string | null

export type UpdateLevelPhoneNumber = string | null

export type UpdateLevelName = string | null

export type UpdateLevelEmail = string | null

export type UpdateLevelCounty = string | null

export type UpdateLevelCommissionNumber = string | null

export type UpdateLevelCommissionExpiry = string | null

export type UpdateLevel = {
  certificates?: UploadedFile[]
  commission_expiry?: UpdateLevelCommissionExpiry
  commission_licenses?: UploadedFile[]
  commission_number?: UpdateLevelCommissionNumber
  county?: UpdateLevelCounty
  email?: UpdateLevelEmail
  level: number
  name?: UpdateLevelName
  phone_number?: UpdateLevelPhoneNumber
  state?: UpdateLevelState
  stripe_account_id?: UpdateLevelStripeAccountId
  timezone?: UpdateLevelTimezone
}

export type UpdateAvailability = {
  ends_at: string
  starts_at: string
}

export type Team = {
  city: string
  first_time_client: boolean
  id: string
  is_priority_enterprise: boolean
  name: string
  organization: Organization
  state: string
  timezone: string
}

export type ShownExhibit = {
  designation: ExhibitDesignation
  download_url: string
  filename: string
  id: string
  index: number
  name: string
}

export type SetWeeklyAvailability = {
  ranges?: AvailabilityRange[]
  timezone: string
  week_start: string
}

export type ScriptStepStatus =
  (typeof ScriptStepStatus)[keyof typeof ScriptStepStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScriptStepStatus = {
  incomplete: 'incomplete',
  in_progress: 'in_progress',
  completed: 'completed',
  skipped: 'skipped',
} as const

export type ScriptStepKey = (typeof ScriptStepKey)[keyof typeof ScriptStepKey]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScriptStepKey = {
  preparation: 'preparation',
  attendance: 'attendance',
  opening: 'opening',
  questioning: 'questioning',
  closing: 'closing',
  review: 'review',
} as const

export type ScriptStepKeyProperty = ScriptStepKey | string

export type ScriptStepActions = { [key: string]: ScriptAction }

export type ScriptStep = {
  actions: ScriptStepActions
  key: ScriptStepKeyProperty
  status: ScriptStepStatus
}

export type ScriptExhibitDesignation =
  | 'plaintiff'
  | 'defendant'
  | 'unknown'
  | null

export type ScriptExhibit = {
  description?: string
  designation?: ScriptExhibitDesignation
  exhibit_number: string
  id: string
  marked_at: string
}

export type ScriptDataObjectV2OutputSteps = { [key: string]: ScriptStep }

export type ScriptDataObjectV2OutputReporterState = string | null

export type ScriptDataObjectV2OutputReporterCounty = string | null

export type ScriptDataObjectV2OutputCurrentStep = ScriptStepKey | string | null

export type ScriptDataObjectV2InputSteps = { [key: string]: ScriptStep }

export type ScriptDataObjectV2InputReporterState = string | null

export type ScriptDataObjectV2InputReporterCounty = string | null

export type ScriptDataObjectV2InputCurrentStep = ScriptStepKey | string | null

export type ScriptDataObjectV2Input = {
  attendees: ScriptAttendeeInput[]
  current_step?: ScriptDataObjectV2InputCurrentStep
  events: EventScriptDataObjectInput[]
  reporter_county?: ScriptDataObjectV2InputReporterCounty
  reporter_state?: ScriptDataObjectV2InputReporterState
  steps: ScriptDataObjectV2InputSteps
  submitted?: boolean
}

export type ScriptAttendeeOutputTranscriptOrder = string | number | null

export type ScriptAttendeeOutputState = string | null

export type ScriptAttendeeOutputPresent = boolean | null

export type ScriptAttendeeOutputIdentityDocument = IdentityDocument | null

export type ScriptAttendeeOutputEmail = string | null

export type ScriptAttendeeOutputCity = string | null

export type ScriptAttendeeOutput = {
  attendee_id: string
  city?: ScriptAttendeeOutputCity
  email?: ScriptAttendeeOutputEmail
  identity_document?: ScriptAttendeeOutputIdentityDocument
  name: string
  present?: ScriptAttendeeOutputPresent
  role: AttendeeRole
  state?: ScriptAttendeeOutputState
  transcript_order?: ScriptAttendeeOutputTranscriptOrder
  zoom_participants?: ZoomParticipant[]
}

export type ScriptDataObjectV2Output = {
  attendees: ScriptAttendeeOutput[]
  current_step?: ScriptDataObjectV2OutputCurrentStep
  events: EventScriptDataObjectOutput[]
  reporter_county?: ScriptDataObjectV2OutputReporterCounty
  reporter_state?: ScriptDataObjectV2OutputReporterState
  steps: ScriptDataObjectV2OutputSteps
  submitted?: boolean
}

export type ScriptAttendeeInputTranscriptOrder = string | number | null

export type ScriptAttendeeInputState = string | null

export type ScriptAttendeeInputPresent = boolean | null

export type ScriptAttendeeInputIdentityDocument = IdentityDocument | null

export type ScriptAttendeeInputEmail = string | null

export type ScriptAttendeeInputCity = string | null

export type ScriptAttendeeInput = {
  attendee_id: string
  city?: ScriptAttendeeInputCity
  email?: ScriptAttendeeInputEmail
  identity_document?: ScriptAttendeeInputIdentityDocument
  name: string
  present?: ScriptAttendeeInputPresent
  role: AttendeeRole
  state?: ScriptAttendeeInputState
  transcript_order?: ScriptAttendeeInputTranscriptOrder
  zoom_participants?: ZoomParticipant[]
}

export type ScriptActionSkip = boolean | null

export type ScriptActionOptional = boolean | null

export type ScriptAction = {
  completed: boolean
  key: string
  optional?: ScriptActionOptional
  skip?: ScriptActionSkip
}

export type SaveCourtReporterDeliverablePayload = {
  deliverable: CourtReporterDeliverableType
  filename: string
  key: string
}

export type ReporterWithAvailability = {
  available: boolean
  reporter: ReporterBase
}

export type ReporterSilo = (typeof ReporterSilo)[keyof typeof ReporterSilo]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReporterSilo = {
  digital_reporter: 'digital_reporter',
  court_reporter: 'court_reporter',
} as const

export type ReporterRole = (typeof ReporterRole)[keyof typeof ReporterRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReporterRole = {
  court_reporter: 'court_reporter',
  digital_reporter: 'digital_reporter',
} as const

export type ReporterFeedbackTranscriptOrder = {
  turnaround_hours: number
}

export type ReporterFeedbackParticipantMappingParticipantUserId = string | null

export type ReporterFeedbackParticipantMapping = {
  join_time: string
  meeting_instance_id: string
  participant_user_id?: ReporterFeedbackParticipantMappingParticipantUserId
  user_id: string
  user_name: string
}

export type ReporterFeedbackExhibit = {
  description?: string
  designation?: ExhibitDesignation
  id: string
  marked_at: string
  name: string
}

export type ReporterFeedbackCorrectedLowConfidenceWordSpeakerId = string | null

export type ReporterFeedbackCorrectedLowConfidenceWord = {
  correct_text: string
  end_time: number
  speaker_id?: ReporterFeedbackCorrectedLowConfidenceWordSpeakerId
  start_time: number
  word: string
}

export type ReporterFeedbackAttendeeEmail = string | null

export type ReporterFeedbackAttendee = {
  email?: ReporterFeedbackAttendeeEmail
  name: string
  present: boolean
  role: string
}

export type ReporterFeedbackRecordPreferences = string | null

export type ReporterFeedback = {
  events_feedbacks: EventFeedback[]
  record_preferences?: ReporterFeedbackRecordPreferences
  reporter_county: string
  reporter_state: string
}

export type ReporterEventTimezone = string | null

export type ReporterEventStatus =
  (typeof ReporterEventStatus)[keyof typeof ReporterEventStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReporterEventStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type ReporterEventResult = EventResult | null

export type ReporterEventRequiredReporterExperienceLevelOverride = number | null

export type ReporterEventRequiredReporterExperienceLevel = number | null

export type ReporterEventReporterStatus =
  (typeof ReporterEventReporterStatus)[keyof typeof ReporterEventReporterStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReporterEventReporterStatus = {
  available: 'available',
  unavailable: 'unavailable',
  booked: 'booked',
  overlapping: 'overlapping',
  overlapping_related: 'overlapping_related',
  past: 'past',
  waiting: 'waiting',
  cancelled: 'cancelled',
} as const

export type ReporterEventReporterSilo = ReporterSilo | null

export type ReporterEventRelatedEventsType = 'back-to-back' | 'hearing' | null

export type ReporterEventMeetingId = string | null

export type ReporterEventLivestreamUrl = string | null

export type ReporterEventLivestreamKey = string | null

export type ReporterEventIsZoombotRecordingEnabled = boolean | null

export type ReporterEventIsReporterEligible = boolean | null

export type ReporterEventGeneralStatus =
  (typeof ReporterEventGeneralStatus)[keyof typeof ReporterEventGeneralStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReporterEventGeneralStatus = {
  available: 'available',
  unavailable: 'unavailable',
  booked: 'booked',
  past: 'past',
  waiting: 'waiting',
  cancelled: 'cancelled',
} as const

export type ReporterEventFirstRefusalHold = FirstRefusalHold | null

export type ReporterEventEventLevelAtBooking = number | null

export type ReporterEventEventLevel = number | null

export type ReporterEventErrataPolicy = ErrataPolicy | null

export type ReporterEventCourtReporterSource = CourtReporterSource | null

export type ReporterEventClaimNumber = string | null

export type ReporterEventBundle = EventBundle | null

export type ReporterEventBooking = Booking | null

export type ReporterEvent = {
  attendees: Attendee[]
  readonly attorney_emails: readonly string[]
  readonly available_related_events_url: string
  readonly available_reporters_url: string
  readonly booked_related_events_url: string
  booking?: ReporterEventBooking
  readonly booking_url: string
  bookings: Booking[]
  bundle?: ReporterEventBundle
  can_order_for_oc: boolean
  case: Case
  claim_number?: ReporterEventClaimNumber
  readonly cna_transcript_orders_enabled: boolean
  readonly computed_required_reporter_experience_level: number
  court_reporter_source?: ReporterEventCourtReporterSource
  created: string
  datetime: string
  duration: number
  readonly end_datetime: string
  readonly end_url: string
  errata_policy?: ReporterEventErrataPolicy
  event_level?: ReporterEventEventLevel
  event_level_at_booking?: ReporterEventEventLevelAtBooking
  readonly exhibits_url: string
  readonly feedback_url: string
  first_refusal_hold?: ReporterEventFirstRefusalHold
  general_status: ReporterEventGeneralStatus
  readonly has_related_events: boolean
  id: string
  readonly is_cancelable: boolean
  readonly is_cancelled: boolean
  is_deposition_in_aid: boolean
  readonly is_ended: boolean
  readonly is_ongoing: boolean
  is_reporter_eligible?: ReporterEventIsReporterEligible
  readonly is_transcript_order_required: boolean
  readonly is_upcoming: boolean
  is_waiting_for_reporter_feedback: boolean
  is_zoombot_recording_enabled?: ReporterEventIsZoombotRecordingEnabled
  readonly join_info_url: string
  livestream_key?: ReporterEventLivestreamKey
  livestream_url?: ReporterEventLivestreamUrl
  readonly low_confidence_words_url: string
  readonly media_resources_url: string
  meeting_id?: ReporterEventMeetingId
  name: string
  readonly presign_id_screenshot_upload_url: string
  recording: Recording
  related_events_type?: ReporterEventRelatedEventsType
  readonly related_events_url: string
  reporter_silo?: ReporterEventReporterSilo
  reporter_status: ReporterEventReporterStatus
  required_badges?: Badge[]
  required_reporter_experience_level?: ReporterEventRequiredReporterExperienceLevel
  required_reporter_experience_level_override?: ReporterEventRequiredReporterExperienceLevelOverride
  result?: ReporterEventResult
  scoped_to_reporter_id: string
  readonly script_data_url: string
  short_id: string
  status: ReporterEventStatus
  readonly submit_feedback_url: string
  readonly submit_script_data_url: string
  team: Team
  timezone?: ReporterEventTimezone
  type: EventType
  uses_external_zoom_meeting: boolean
}

export type ReporterBaseTimezone = string | null

export type ReporterBaseStripeAccountId = string | null

export type ReporterBaseState = string | null

export type ReporterBasePhoneNumber = string | null

export type ReporterBaseCounty = string | null

export type ReporterBaseCommissionNumber = string | null

export type ReporterBaseCommissionExpiry = string | null

export type ReporterBase = {
  readonly availabilities_url: string
  badges?: Badge[]
  commission_expiry?: ReporterBaseCommissionExpiry
  commission_number?: ReporterBaseCommissionNumber
  county?: ReporterBaseCounty
  readonly deactivate_url: string
  email: string
  experience_level: number
  readonly has_documents: boolean
  readonly has_expired_commission: boolean
  readonly has_missing_settings: boolean
  id: string
  is_active: boolean
  level: number
  readonly level_url: string
  name: string
  phone_number?: ReporterBasePhoneNumber
  readonly reactivate_url: string
  requires_commission_number: boolean
  readonly resend_welcome_email_url: string
  role?: ReporterRole
  state?: ReporterBaseState
  stripe_account_id?: ReporterBaseStripeAccountId
  readonly stripe_account_url: string
  timezone?: ReporterBaseTimezone
  readonly url: string
  readonly weekly_availability_url: string
}

export type ReporterTimezone = string | null

export type ReporterStripeAccountId = string | null

export type ReporterState = string | null

export type ReporterPhoneNumber = string | null

export type ReporterCounty = string | null

export type ReporterCommissionNumber = string | null

export type ReporterCommissionExpiry = string | null

export type Reporter = {
  readonly availabilities_url: string
  badges?: Badge[]
  certificates?: UploadedFile[]
  commission_expiry?: ReporterCommissionExpiry
  commission_licenses?: UploadedFile[]
  commission_number?: ReporterCommissionNumber
  county?: ReporterCounty
  readonly deactivate_url: string
  email: string
  experience_level: number
  readonly has_documents: boolean
  readonly has_expired_commission: boolean
  readonly has_missing_settings: boolean
  id: string
  is_active: boolean
  level: number
  readonly level_url: string
  name: string
  phone_number?: ReporterPhoneNumber
  readonly presign_certificate_upload_url: string
  readonly presign_commission_license_upload_url: string
  readonly reactivate_url: string
  requires_commission_number: boolean
  readonly resend_welcome_email_url: string
  role?: ReporterRole
  state?: ReporterState
  stripe_account_id?: ReporterStripeAccountId
  readonly stripe_account_url: string
  timezone?: ReporterTimezone
  readonly url: string
  readonly weekly_availability_url: string
}

export type RecordingTrimmedAudioLength = number | null

export type RecordingOriginalAudioLength = number | null

export type Recording = {
  client_status: string
  id: string
  is_translator_present: boolean
  name: string
  original_audio_length?: RecordingOriginalAudioLength
  trimmed_audio_length?: RecordingTrimmedAudioLength
}

/**
 * What the reporter recorded. NO_ANSWER also covers "never asked".
 */
export type ReadWaiveAnswer =
  (typeof ReadWaiveAnswer)[keyof typeof ReadWaiveAnswer]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReadWaiveAnswer = {
  no_answer: 'no_answer',
  read: 'read',
  waive: 'waive',
} as const

export type PresignedS3PostResultFields = { [key: string]: unknown }

export type PresignedS3PostResult = {
  fields: PresignedS3PostResultFields
  url: string
}

export type PresignedS3PostResultWithPreview = {
  presigned_post: PresignedS3PostResult
  preview_url: string
}

export type PresignedPostFields = { [key: string]: string }

export type PresignedPost = {
  fields: PresignedPostFields
  url: string
}

export type PresignCourtReporterDeliverablePayload = {
  deliverable: CourtReporterDeliverableType
  filename: string
  mime_type: string
}

export type Organization = {
  id: string
  is_internal: boolean
  name: string
}

export type OnSiteLocationZip = string | null

export type OnSiteLocationState = string | null

export type OnSiteLocationCity = string | null

export type OnSiteLocationAddress = string | null

export type OnSiteLocation = {
  address?: OnSiteLocationAddress
  city?: OnSiteLocationCity
  state?: OnSiteLocationState
  zip?: OnSiteLocationZip
}

export type MediaResourceOriginalName = string | null

export type MediaResource = {
  format: string
  id: string
  media_type: string
  original_name?: MediaResourceOriginalName
  /** @minLength 1 */
  url: string
}

export type LowConfidenceWordStatus =
  (typeof LowConfidenceWordStatus)[keyof typeof LowConfidenceWordStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LowConfidenceWordStatus = {
  unresolved: 'unresolved',
  corrected: 'corrected',
  unclear: 'unclear',
} as const

export type LowConfidenceWordSpeakerId = string | null

export type LowConfidenceWord = {
  correct_text: string
  end_time: number
  speaker_id?: LowConfidenceWordSpeakerId
  start_time: number
  status: LowConfidenceWordStatus
  word: string
}

export type JoinInfoJoinUrl = string | null

export type JoinInfoJoinPhoneNumber = string | null

export type JoinInfoJoinPassword = string | null

export type JoinInfoJoinCode = string | null

export type JoinInfoHostUrl = string | null

export type JoinInfo = {
  host_url?: JoinInfoHostUrl
  join_code?: JoinInfoJoinCode
  join_password?: JoinInfoJoinPassword
  join_phone_number?: JoinInfoJoinPhoneNumber
  join_url?: JoinInfoJoinUrl
}

export type IdentityDocumentType =
  (typeof IdentityDocumentType)[keyof typeof IdentityDocumentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdentityDocumentType = {
  drivers_license: 'drivers_license',
  passport: 'passport',
  police_badge: 'police_badge',
  state_id: 'state_id',
  other: 'other',
} as const

export type IdentityDocumentStatus =
  (typeof IdentityDocumentStatus)[keyof typeof IdentityDocumentStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdentityDocumentStatus = {
  valid: 'valid',
  stipulate: 'stipulate',
  expired: 'expired',
  not_present: 'not_present',
} as const

export type IdentityDocumentStatusProperty = IdentityDocumentStatus | null

export type IdentityDocumentPhotoIdVerified = boolean | null

export type IdentityDocumentNumber = string | null

export type IdentityDocumentDocumentType = IdentityDocumentType | null

export type IdentityDocument = {
  document_type?: IdentityDocumentDocumentType
  number?: IdentityDocumentNumber
  photo_id_verified?: IdentityDocumentPhotoIdVerified
  status?: IdentityDocumentStatusProperty
}

export type HTTPValidationError = {
  detail?: ValidationError[]
}

/**
 * The hold on a rescheduled event, offering it back to the DR who lost it (PRD §2.3.3).

Answered only to that DR and to the reporter-agnostic Ops fetches. Naming the holder to
anyone else would undo the withholding `is_reporter_eligible` already does.

The holder is an id: Parrot leaves the name to this app, which holds its own DR records.
 */
export type FirstRefusalHold = {
  expires_at: string
  holder_id: string
}

export type ExhibitDesignation =
  (typeof ExhibitDesignation)[keyof typeof ExhibitDesignation]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExhibitDesignation = {
  plaintiff: 'plaintiff',
  defendant: 'defendant',
  unknown: 'unknown',
} as const

export type Exhibit = {
  filename: string
  id: string
  key: string
  name: string
  status: string
  /** @minLength 1 */
  url: string
}

export type EventType = (typeof EventType)[keyof typeof EventType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventType = {
  deposition: 'deposition',
  examination_under_oath: 'examination_under_oath',
  hearing: 'hearing',
  meet_and_confer: 'meet_and_confer',
} as const

export type EventScriptDataObjectOutputWitnessRequestedTranscript =
  | boolean
  | null

export type EventScriptDataObjectOutputTimestamps = string | null

export type EventScriptDataObjectOutputStepsAnyOf = {
  [key: string]: ScriptStep
}

export type EventScriptDataObjectOutputSteps =
  EventScriptDataObjectOutputStepsAnyOf | null

export type EventScriptDataObjectOutputSpellings = string | null

export type EventScriptDataObjectOutputShownExhibits = ShownExhibit[] | null

export type EventScriptDataObjectOutputResult = EventResult | null

export type EventScriptDataObjectOutputReasonForCna = string | null

export type EventScriptDataObjectOutputOtherReason = string | null

export type EventScriptDataObjectOutputNotes = string | null

export type EventScriptDataObjectOutputLowConfidenceWords =
  | LowConfidenceWord[]
  | null

export type EventScriptDataObjectOutputLastTimestamp = string | null

export type EventScriptDataObjectOutputFirstSkippedStep =
  | ScriptStepKey
  | string
  | null

export type EventScriptDataObjectOutputExhibits = ScriptExhibit[] | null

export type EventScriptDataObjectOutputErrataRecipientAttendeeId = string | null

export type EventScriptDataObjectOutputCurrentStep =
  | ScriptStepKey
  | string
  | null

export type EventScriptDataObjectOutputConfirmedNoExhibits = boolean | null

export type EventScriptDataObjectOutputConductingNotes = string | null

export type EventScriptDataObjectOutputCnaDeclaredAt = string | null

export type EventScriptDataObjectOutput = {
  attendees: ScriptAttendeeOutput[]
  cna_declared_at?: EventScriptDataObjectOutputCnaDeclaredAt
  conducting_notes?: EventScriptDataObjectOutputConductingNotes
  confirmed_no_exhibits?: EventScriptDataObjectOutputConfirmedNoExhibits
  current_step?: EventScriptDataObjectOutputCurrentStep
  errata_recipient_attendee_id?: EventScriptDataObjectOutputErrataRecipientAttendeeId
  exhibits?: EventScriptDataObjectOutputExhibits
  first_skipped_step?: EventScriptDataObjectOutputFirstSkippedStep
  is_on_record: boolean
  last_timestamp?: EventScriptDataObjectOutputLastTimestamp
  low_confidence_words?: EventScriptDataObjectOutputLowConfidenceWords
  notes?: EventScriptDataObjectOutputNotes
  order_transcript: boolean
  other_reason?: EventScriptDataObjectOutputOtherReason
  read_waive_answer?: ReadWaiveAnswer
  reason_for_cna?: EventScriptDataObjectOutputReasonForCna
  result?: EventScriptDataObjectOutputResult
  shown_exhibits?: EventScriptDataObjectOutputShownExhibits
  spellings?: EventScriptDataObjectOutputSpellings
  steps?: EventScriptDataObjectOutputSteps
  submitted?: boolean
  timestamps?: EventScriptDataObjectOutputTimestamps
  witness_requested_transcript?: EventScriptDataObjectOutputWitnessRequestedTranscript
  zoom_participants: ZoomParticipant[]
}

export type EventScriptDataObjectInputWitnessRequestedTranscript =
  | boolean
  | null

export type EventScriptDataObjectInputTimestamps = string | null

export type EventScriptDataObjectInputStepsAnyOf = { [key: string]: ScriptStep }

export type EventScriptDataObjectInputSteps =
  EventScriptDataObjectInputStepsAnyOf | null

export type EventScriptDataObjectInputSpellings = string | null

export type EventScriptDataObjectInputShownExhibits = ShownExhibit[] | null

export type EventScriptDataObjectInputResult = EventResult | null

export type EventScriptDataObjectInputReasonForCna = string | null

export type EventScriptDataObjectInputOtherReason = string | null

export type EventScriptDataObjectInputNotes = string | null

export type EventScriptDataObjectInputLowConfidenceWords =
  | LowConfidenceWord[]
  | null

export type EventScriptDataObjectInputLastTimestamp = string | null

export type EventScriptDataObjectInputFirstSkippedStep =
  | ScriptStepKey
  | string
  | null

export type EventScriptDataObjectInputExhibits = ScriptExhibit[] | null

export type EventScriptDataObjectInputErrataRecipientAttendeeId = string | null

export type EventScriptDataObjectInputCurrentStep =
  | ScriptStepKey
  | string
  | null

export type EventScriptDataObjectInputConfirmedNoExhibits = boolean | null

export type EventScriptDataObjectInputConductingNotes = string | null

export type EventScriptDataObjectInputCnaDeclaredAt = string | null

export type EventScriptDataObjectInput = {
  attendees: ScriptAttendeeInput[]
  cna_declared_at?: EventScriptDataObjectInputCnaDeclaredAt
  conducting_notes?: EventScriptDataObjectInputConductingNotes
  confirmed_no_exhibits?: EventScriptDataObjectInputConfirmedNoExhibits
  current_step?: EventScriptDataObjectInputCurrentStep
  errata_recipient_attendee_id?: EventScriptDataObjectInputErrataRecipientAttendeeId
  exhibits?: EventScriptDataObjectInputExhibits
  first_skipped_step?: EventScriptDataObjectInputFirstSkippedStep
  is_on_record: boolean
  last_timestamp?: EventScriptDataObjectInputLastTimestamp
  low_confidence_words?: EventScriptDataObjectInputLowConfidenceWords
  notes?: EventScriptDataObjectInputNotes
  order_transcript: boolean
  other_reason?: EventScriptDataObjectInputOtherReason
  read_waive_answer?: ReadWaiveAnswer
  reason_for_cna?: EventScriptDataObjectInputReasonForCna
  result?: EventScriptDataObjectInputResult
  shown_exhibits?: EventScriptDataObjectInputShownExhibits
  spellings?: EventScriptDataObjectInputSpellings
  steps?: EventScriptDataObjectInputSteps
  submitted?: boolean
  timestamps?: EventScriptDataObjectInputTimestamps
  witness_requested_transcript?: EventScriptDataObjectInputWitnessRequestedTranscript
  zoom_participants: ZoomParticipant[]
}

export type EventResult = (typeof EventResult)[keyof typeof EventResult]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventResult = {
  completed: 'completed',
  completed_no_show: 'completed_no_show',
  canceled: 'canceled',
  canceled_cna: 'canceled_cna',
  reset: 'reset',
  rescheduled: 'rescheduled',
} as const

export type EventParticipantPhoneNumber = string | null

export type EventParticipantParticipantUuid = string | null

export type EventParticipantParticipantUserId = string | null

export type EventParticipantEmail = string | null

export type EventParticipant = {
  created_at: string
  email?: EventParticipantEmail
  event_id: string
  id: string
  join_time: string
  meeting_instance_id: string
  participant_user_id?: EventParticipantParticipantUserId
  participant_uuid?: EventParticipantParticipantUuid
  phone_number?: EventParticipantPhoneNumber
  user_id: string
  user_name: string
}

export type EventFormat = (typeof EventFormat)[keyof typeof EventFormat]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventFormat = {
  remote: 'remote',
  on_site: 'on_site',
} as const

export type EventFeedbackWitnessState = string | null

export type EventFeedbackWitnessCity = string | null

export type EventFeedbackTurnaroundHours = number | null

export type EventFeedbackTranscriptOrdersAnyOf = {
  [key: string]: ReporterFeedbackTranscriptOrder
}

export type EventFeedbackTranscriptOrders =
  EventFeedbackTranscriptOrdersAnyOf | null

export type EventFeedbackTimestampLog = string | null

export type EventFeedbackSpellings = string | null

export type EventFeedbackShownExhibits = ShownExhibit[] | null

export type EventFeedbackPhotoIdVerified = boolean | null

export type EventFeedbackParticipantsMappingAnyOf = {
  [key: string]: ReporterFeedbackParticipantMapping[]
}

export type EventFeedbackParticipantsMapping =
  EventFeedbackParticipantsMappingAnyOf | null

export type EventFeedbackIdType = string | null

export type EventFeedbackIdStatus = string | null

export type EventFeedbackIdScreenshots = UploadedFile[] | null

export type EventFeedbackIdNumber = string | null

export type EventFeedbackExhibits = ReporterFeedbackExhibit[] | null

export type EventFeedbackErrataRecipientEmail = string | null

export type EventFeedbackCorrectedLowConfidenceWords =
  | ReporterFeedbackCorrectedLowConfidenceWord[]
  | null

export type EventFeedbackConfirmedNoExhibits = boolean | null

export type EventFeedbackCnaTypeOtherText = string | null

export type EventFeedbackCnaType = string | null

export type EventFeedbackCnaDeclaredAt = string | null

export type EventFeedbackAdditionalNotes = string | null

export type EventFeedback = {
  additional_notes?: EventFeedbackAdditionalNotes
  attendees: ReporterFeedbackAttendee[]
  cna_declared_at?: EventFeedbackCnaDeclaredAt
  cna_type?: EventFeedbackCnaType
  cna_type_other_text?: EventFeedbackCnaTypeOtherText
  confirmed_no_exhibits?: EventFeedbackConfirmedNoExhibits
  corrected_low_confidence_words?: EventFeedbackCorrectedLowConfidenceWords
  errata_recipient_email?: EventFeedbackErrataRecipientEmail
  exhibits?: EventFeedbackExhibits
  id_number?: EventFeedbackIdNumber
  id_screenshots?: EventFeedbackIdScreenshots
  id_status?: EventFeedbackIdStatus
  id_type?: EventFeedbackIdType
  participants_mapping?: EventFeedbackParticipantsMapping
  photo_id_verified?: EventFeedbackPhotoIdVerified
  read_waive_answer?: ReadWaiveAnswer
  result: EventResult
  shown_exhibits?: EventFeedbackShownExhibits
  spellings?: EventFeedbackSpellings
  timestamp_log?: EventFeedbackTimestampLog
  transcript_ordered: boolean
  transcript_orders?: EventFeedbackTranscriptOrders
  turnaround_hours?: EventFeedbackTurnaroundHours
  witness_city?: EventFeedbackWitnessCity
  witness_requested_transcript: boolean
  witness_state?: EventFeedbackWitnessState
}

export type EventBundleRequiredLevel = number | null

export type EventBundleRequiredBadges = Badge[] | null

export type EventBundleBookedBy = string | null

/**
 * The back-to-back run an event belongs to, as Parrot derives it (its PRD §2.3.5).

Present only on a fetch that resolves eligibility, and null for an event not in a run.
Membership is derived by Parrot on every read rather than stored, so cancelling,
rescheduling or booking a member dissolves the run with nothing to write — which is why
there is no bundle id anywhere in this app's own state.

`booked_by` is what tells an open run from one a DR already holds. Not `required_level`:
that is null for a booked run *and* for an open run holding an unscored event, which
nobody can complete. Branch on `booked_by`.
 */
export type EventBundle = {
  booked_by?: EventBundleBookedBy
  event_ids: string[]
  id: string
  required_badges?: EventBundleRequiredBadges
  required_level?: EventBundleRequiredLevel
}

/**
 * The jurisdiction's read/waive rule, resolved by parrot.

It turns on more than the state -- federal venue, event type and reporter
type all feed it -- so the script reads it rather than deriving it.
 */
export type ErrataPolicy = (typeof ErrataPolicy)[keyof typeof ErrataPolicy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrataPolicy = {
  always_read: 'always_read',
  always_waive: 'always_waive',
  read_by_default: 'read_by_default',
  waive_by_default: 'waive_by_default',
} as const

export type CreateReporterStripeAccountId = string | null

export type CreateReporterState = string | null

export type CreateReporterPhoneNumber = string | null

export type CreateReporterCounty = string | null

export type CreateReporterCommissionNumber = string | null

export type CreateReporterCommissionExpiry = string | null

export type CreateReporter = {
  commission_expiry?: CreateReporterCommissionExpiry
  commission_number?: CreateReporterCommissionNumber
  county?: CreateReporterCounty
  email: string
  experience_level?: number
  is_active?: boolean
  name: string
  phone_number?: CreateReporterPhoneNumber
  state?: CreateReporterState
  stripe_account_id?: CreateReporterStripeAccountId
}

export type CreateAvailability = {
  ends_at: string
  starts_at: string
}

export type CrNotJoinedPayload = {
  resolved: boolean
}

export type CourtReporterWitnessEventWitnessName = string | null

export type CourtReporterWitnessEventStatus =
  (typeof CourtReporterWitnessEventStatus)[keyof typeof CourtReporterWitnessEventStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterWitnessEventStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type CourtReporterWitnessEventRecording = WitnessEventRecording | null

export type CourtReporterWitnessEvent = {
  deliverables_url: string
  id: string
  media_resources_url: string
  recording?: CourtReporterWitnessEventRecording
  status: CourtReporterWitnessEventStatus
  witness_name?: CourtReporterWitnessEventWitnessName
}

export type CourtReporterSource =
  (typeof CourtReporterSource)[keyof typeof CourtReporterSource]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterSource = {
  filevine: 'filevine',
  requested: 'requested',
  client_own: 'client_own',
} as const

export type CourtReporterEventDetailTimezone = string | null

export type CourtReporterEventDetailStatus =
  (typeof CourtReporterEventDetailStatus)[keyof typeof CourtReporterEventDetailStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterEventDetailStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type CourtReporterEventDetailResult = EventResult | null

export type CourtReporterEventDetailReporterSilo = ReporterSilo | null

export type CourtReporterEventDetailOnSiteLocation = OnSiteLocation | null

export type CourtReporterEventDetailEventFormat = EventFormat | null

export type CourtReporterEventDetailCourtReporterStatus =
  (typeof CourtReporterEventDetailCourtReporterStatus)[keyof typeof CourtReporterEventDetailCourtReporterStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterEventDetailCourtReporterStatus = {
  booked: 'booked',
  past: 'past',
  cancelled: 'cancelled',
} as const

export type CourtReporterEventDetailCourtReporterSource =
  CourtReporterSource | null

export type CourtReporterEventDetailClaimNumber = string | null

export type CourtReporterEventDetail = {
  attendees: Attendee[]
  case: Case
  claim_number?: CourtReporterEventDetailClaimNumber
  court_reporter_booking: CalendarCourtReporterBooking
  court_reporter_source?: CourtReporterEventDetailCourtReporterSource
  court_reporter_status: CourtReporterEventDetailCourtReporterStatus
  datetime: string
  readonly deliverables_url: string
  duration: number
  readonly end_datetime: string
  event_format?: CourtReporterEventDetailEventFormat
  readonly exhibits_url: string
  id: string
  is_split_result?: boolean
  is_splitting?: boolean
  is_waiting_for_reporter_feedback?: boolean
  readonly join_info_url: string
  readonly media_resources_url: string
  name: string
  on_site_location?: CourtReporterEventDetailOnSiteLocation
  recording: Recording
  reporter_silo?: CourtReporterEventDetailReporterSilo
  result?: CourtReporterEventDetailResult
  short_id: string
  status: CourtReporterEventDetailStatus
  team: Team
  timezone?: CourtReporterEventDetailTimezone
  type: EventType
  uses_external_zoom_meeting: boolean
  witness_events: CourtReporterWitnessEvent[]
}

export type CourtReporterDeliverableUploadUrl = {
  key: string
  presign_data: PresignedPost
}

export type CourtReporterDeliverableType =
  (typeof CourtReporterDeliverableType)[keyof typeof CourtReporterDeliverableType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterDeliverableType = {
  invoice: 'invoice',
  transcript_pdf: 'transcript_pdf',
  transcript_txt: 'transcript_txt',
} as const

export type CourtReporterDeliverableOriginalName = string | null

/**
 * A CR invoice or certified transcript file on an event, wherever it was uploaded from.
 */
export type CourtReporterDeliverable = {
  created: string
  deliverable: CourtReporterDeliverableType
  format: string
  id: string
  original_name?: CourtReporterDeliverableOriginalName
  url: string
}

export type CourtReporterBookingStatus =
  (typeof CourtReporterBookingStatus)[keyof typeof CourtReporterBookingStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterBookingStatus = {
  PENDING: 'PENDING',
  REQUESTED: 'REQUESTED',
  CONFIRMED: 'CONFIRMED',
} as const

export type CourtReporterAdminEventDetailTimezone = string | null

export type CourtReporterAdminEventDetailStatus =
  (typeof CourtReporterAdminEventDetailStatus)[keyof typeof CourtReporterAdminEventDetailStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterAdminEventDetailStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type CourtReporterAdminEventDetailResult = EventResult | null

export type CourtReporterAdminEventDetailReporterSilo = ReporterSilo | null

export type CourtReporterAdminEventDetailOnSiteLocation = OnSiteLocation | null

export type CourtReporterAdminEventDetailGeneralStatus =
  (typeof CourtReporterAdminEventDetailGeneralStatus)[keyof typeof CourtReporterAdminEventDetailGeneralStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterAdminEventDetailGeneralStatus = {
  available: 'available',
  unavailable: 'unavailable',
  requested: 'requested',
  booked: 'booked',
  past: 'past',
  cancelled: 'cancelled',
} as const

export type CourtReporterAdminEventDetailEventFormat = EventFormat | null

export type CourtReporterAdminEventDetailCourtReporterStatus =
  (typeof CourtReporterAdminEventDetailCourtReporterStatus)[keyof typeof CourtReporterAdminEventDetailCourtReporterStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourtReporterAdminEventDetailCourtReporterStatus = {
  booked: 'booked',
  past: 'past',
  cancelled: 'cancelled',
} as const

export type CourtReporterAdminEventDetailCourtReporterSource =
  CourtReporterSource | null

export type CourtReporterAdminEventDetailCourtReporterBooking =
  CalendarCourtReporterBooking | null

export type CourtReporterAdminEventDetailClaimNumber = string | null

/**
 * The CR event page as Ops see it, read off the CR booking when the event has one.
 */
export type CourtReporterAdminEventDetail = {
  attendees: Attendee[]
  case: Case
  claim_number?: CourtReporterAdminEventDetailClaimNumber
  court_reporter_booking?: CourtReporterAdminEventDetailCourtReporterBooking
  court_reporter_source?: CourtReporterAdminEventDetailCourtReporterSource
  court_reporter_status: CourtReporterAdminEventDetailCourtReporterStatus
  datetime: string
  readonly deliverables_url: string
  duration: number
  readonly end_datetime: string
  event_format?: CourtReporterAdminEventDetailEventFormat
  readonly exhibits_url: string
  general_status: CourtReporterAdminEventDetailGeneralStatus
  id: string
  is_split_result?: boolean
  is_splitting?: boolean
  is_waiting_for_reporter_feedback?: boolean
  readonly join_info_url: string
  readonly media_resources_url: string
  name: string
  on_site_location?: CourtReporterAdminEventDetailOnSiteLocation
  recording: Recording
  reporter_silo?: CourtReporterAdminEventDetailReporterSilo
  result?: CourtReporterAdminEventDetailResult
  short_id: string
  status: CourtReporterAdminEventDetailStatus
  team: Team
  timezone?: CourtReporterAdminEventDetailTimezone
  type: EventType
  uses_external_zoom_meeting: boolean
  witness_events: CourtReporterWitnessEvent[]
}

export type CourtReporterStates = string[] | null

export type CourtReporterPhoneNumber = string | null

export type CourtReporterIsActive = boolean | null

export type CourtReporterCompanyName = string | null

export type CourtReporter = {
  company_name?: CourtReporterCompanyName
  email: string
  id: string
  is_active?: CourtReporterIsActive
  name: string
  phone_number?: CourtReporterPhoneNumber
  states?: CourtReporterStates
}

export type ChangedByName = string | null

export type ChangedById = string | null

export type ChangedByEmail = string | null

export type ChangedBy = {
  email?: ChangedByEmail
  id?: ChangedById
  name?: ChangedByName
}

export type CaseState = string | null

export type CaseNumber = string | null

export type CaseCounty = string | null

export type Case = {
  county?: CaseCounty
  id: string
  is_claim: boolean
  name: string
  number?: CaseNumber
  state?: CaseState
}

export type CalendarReporterEventStatus =
  (typeof CalendarReporterEventStatus)[keyof typeof CalendarReporterEventStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarReporterEventStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type CalendarReporterEventReporterStatus =
  (typeof CalendarReporterEventReporterStatus)[keyof typeof CalendarReporterEventReporterStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarReporterEventReporterStatus = {
  available: 'available',
  unavailable: 'unavailable',
  booked: 'booked',
  overlapping: 'overlapping',
  overlapping_related: 'overlapping_related',
  past: 'past',
  waiting: 'waiting',
  cancelled: 'cancelled',
} as const

export type CalendarReporterEventReporterSilo = ReporterSilo | null

export type CalendarReporterEventRelatedEventsType =
  | 'back-to-back'
  | 'hearing'
  | null

export type CalendarReporterEventGeneralStatus =
  (typeof CalendarReporterEventGeneralStatus)[keyof typeof CalendarReporterEventGeneralStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarReporterEventGeneralStatus = {
  available: 'available',
  unavailable: 'unavailable',
  booked: 'booked',
  past: 'past',
  waiting: 'waiting',
  cancelled: 'cancelled',
} as const

export type CalendarReporterEventFirstRefusalHold = FirstRefusalHold | null

export type CalendarReporterEventEventLevelAtBooking = number | null

export type CalendarReporterEventEventLevel = number | null

export type CalendarReporterEventCourtReporterSource =
  CourtReporterSource | null

export type CalendarReporterEventClaimNumber = string | null

/**
 * Recording data exposed by Parrot's compact calendar feed.
 */
export type CalendarRecording = {
  is_translator_present: boolean
}

export type CalendarOrganization = {
  id: string
  name: string
}

export type CalendarOffice = {
  id: string
  name: string
  organization: CalendarOrganization
  state: string
}

export type CalendarReporterEvent = {
  attendees: Attendee[]
  available_related_events_url: string
  available_reporters_url: string
  booked_related_events_url: string
  booking_url: string
  case: Case
  claim_number?: CalendarReporterEventClaimNumber
  computed_required_reporter_experience_level: number
  court_reporter_source?: CalendarReporterEventCourtReporterSource
  datetime: string
  duration: number
  end_datetime: string
  event_level: CalendarReporterEventEventLevel
  event_level_at_booking: CalendarReporterEventEventLevelAtBooking
  first_refusal_hold: CalendarReporterEventFirstRefusalHold
  general_status: CalendarReporterEventGeneralStatus
  has_related_events: boolean
  id: string
  is_cancelable: boolean
  is_waiting_for_reporter_feedback: boolean
  name: string
  recording: CalendarRecording
  related_events_type?: CalendarReporterEventRelatedEventsType
  related_events_url: string
  reporter_silo?: CalendarReporterEventReporterSilo
  reporter_status: CalendarReporterEventReporterStatus
  required_badges: Badge[]
  status: CalendarReporterEventStatus
  team: CalendarOffice
  type: EventType
}

export type CalendarCourtReporterEventTimezone = string | null

export type CalendarCourtReporterEventStatus =
  (typeof CalendarCourtReporterEventStatus)[keyof typeof CalendarCourtReporterEventStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarCourtReporterEventStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type CalendarCourtReporterEventReporterSilo = ReporterSilo | null

export type CalendarCourtReporterEventOnSiteLocation = OnSiteLocation | null

export type CalendarCourtReporterEventEventFormat = EventFormat | null

export type CalendarCourtReporterEventCourtReporterStatus =
  (typeof CalendarCourtReporterEventCourtReporterStatus)[keyof typeof CalendarCourtReporterEventCourtReporterStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarCourtReporterEventCourtReporterStatus = {
  booked: 'booked',
  past: 'past',
  cancelled: 'cancelled',
} as const

export type CalendarCourtReporterEventCourtReporterSource =
  CourtReporterSource | null

export type CalendarCourtReporterEventClaimNumber = string | null

export type CalendarCourtReporterEvent = {
  attendees: Attendee[]
  case: Case
  claim_number?: CalendarCourtReporterEventClaimNumber
  court_reporter_booking: CalendarCourtReporterBooking
  court_reporter_source?: CalendarCourtReporterEventCourtReporterSource
  court_reporter_status: CalendarCourtReporterEventCourtReporterStatus
  datetime: string
  duration: number
  readonly end_datetime: string
  event_format?: CalendarCourtReporterEventEventFormat
  id: string
  name: string
  on_site_location?: CalendarCourtReporterEventOnSiteLocation
  recording: CalendarRecording
  reporter_silo?: CalendarCourtReporterEventReporterSilo
  status: CalendarCourtReporterEventStatus
  team: CalendarOffice
  timezone?: CalendarCourtReporterEventTimezone
  type: EventType
}

export type CalendarCourtReporterBookingCancelledAt = string | null

export type CalendarCourtReporterBookingCancellationReason = string | null

/**
 * The event's uncancelled CR booking, confirmed or still waiting for an answer.

Scoped to one CR, it is that CR's own booking, which may be cancelled.
 */
export type CalendarCourtReporterBooking = {
  cancellation_reason?: CalendarCourtReporterBookingCancellationReason
  cancelled_at?: CalendarCourtReporterBookingCancelledAt
  court_reporter_id: string
  court_reporter_name: string
  id: string
  status: CourtReporterBookingStatus
}

export type CalendarCourtReporterAdminEventTimezone = string | null

export type CalendarCourtReporterAdminEventStatus =
  (typeof CalendarCourtReporterAdminEventStatus)[keyof typeof CalendarCourtReporterAdminEventStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarCourtReporterAdminEventStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type CalendarCourtReporterAdminEventReporterSilo = ReporterSilo | null

export type CalendarCourtReporterAdminEventOnSiteLocation =
  OnSiteLocation | null

export type CalendarCourtReporterAdminEventGeneralStatus =
  (typeof CalendarCourtReporterAdminEventGeneralStatus)[keyof typeof CalendarCourtReporterAdminEventGeneralStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarCourtReporterAdminEventGeneralStatus = {
  available: 'available',
  unavailable: 'unavailable',
  requested: 'requested',
  booked: 'booked',
  past: 'past',
  cancelled: 'cancelled',
} as const

export type CalendarCourtReporterAdminEventEventFormat = EventFormat | null

export type CalendarCourtReporterAdminEventCourtReporterSource =
  CourtReporterSource | null

export type CalendarCourtReporterAdminEventCourtReporterBooking =
  CalendarCourtReporterBooking | null

export type CalendarCourtReporterAdminEventClaimNumber = string | null

export type CalendarCourtReporterAdminEvent = {
  attendees: Attendee[]
  case: Case
  claim_number?: CalendarCourtReporterAdminEventClaimNumber
  court_reporter_booking?: CalendarCourtReporterAdminEventCourtReporterBooking
  readonly court_reporter_booking_url: string
  court_reporter_source?: CalendarCourtReporterAdminEventCourtReporterSource
  datetime: string
  duration: number
  readonly end_datetime: string
  event_format?: CalendarCourtReporterAdminEventEventFormat
  general_status: CalendarCourtReporterAdminEventGeneralStatus
  id: string
  name: string
  on_site_location?: CalendarCourtReporterAdminEventOnSiteLocation
  recording: CalendarRecording
  reporter_silo?: CalendarCourtReporterAdminEventReporterSilo
  status: CalendarCourtReporterAdminEventStatus
  team: CalendarOffice
  timezone?: CalendarCourtReporterAdminEventTimezone
  type: EventType
}

export type CalendarAdminEventStatus =
  (typeof CalendarAdminEventStatus)[keyof typeof CalendarAdminEventStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarAdminEventStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type CalendarAdminEventReporterSilo = ReporterSilo | null

export type CalendarAdminEventReporter = ReporterBase | null

export type CalendarAdminEventRelatedEventsType =
  | 'back-to-back'
  | 'hearing'
  | null

export type CalendarAdminEventGeneralStatus =
  (typeof CalendarAdminEventGeneralStatus)[keyof typeof CalendarAdminEventGeneralStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarAdminEventGeneralStatus = {
  available: 'available',
  unavailable: 'unavailable',
  booked: 'booked',
  past: 'past',
  waiting: 'waiting',
  cancelled: 'cancelled',
} as const

export type CalendarAdminEventFirstRefusalHolder = ReporterBase | null

export type CalendarAdminEventFirstRefusalHold = FirstRefusalHold | null

export type CalendarAdminEventEventLevelAtBooking = number | null

export type CalendarAdminEventEventLevel = number | null

export type CalendarAdminEventCourtReporterSource = CourtReporterSource | null

export type CalendarAdminEventClaimNumber = string | null

export type CalendarAdminEvent = {
  attendees: Attendee[]
  available_reporters_url: string
  booking_url: string
  case: Case
  claim_number?: CalendarAdminEventClaimNumber
  computed_required_reporter_experience_level: number
  court_reporter_source?: CalendarAdminEventCourtReporterSource
  datetime: string
  duration: number
  end_datetime: string
  event_level: CalendarAdminEventEventLevel
  event_level_at_booking: CalendarAdminEventEventLevelAtBooking
  first_refusal_hold: CalendarAdminEventFirstRefusalHold
  first_refusal_holder?: CalendarAdminEventFirstRefusalHolder
  general_status: CalendarAdminEventGeneralStatus
  has_related_events: boolean
  id: string
  is_cancelable: boolean
  is_waiting_for_reporter_feedback: boolean
  name: string
  recording: CalendarRecording
  related_events_type?: CalendarAdminEventRelatedEventsType
  related_events_url: string
  reporter?: CalendarAdminEventReporter
  reporter_silo?: CalendarAdminEventReporterSilo
  required_badges: Badge[]
  status: CalendarAdminEventStatus
  team: CalendarOffice
  type: EventType
}

export type BookingCancelledBy = string | null

export type BookingCancelledAt = string | null

export type BookingCancellationReason = string | null

export type Booking = {
  cancellation_reason?: BookingCancellationReason
  cancelled_at?: BookingCancelledAt
  cancelled_by?: BookingCancelledBy
  created_by: string
  id: string
  is_waiting_for_cna_signature: boolean
  is_waiting_for_cott_signature: boolean
  reporter_id: string
}

export type BookPayload = {
  reporter_id: string
}

export type BookCourtReporterPayload = {
  court_reporter_id: string
}

export type Badge = (typeof Badge)[keyof typeof Badge]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Badge = {
  session_assistant: 'session_assistant',
  dia: 'dia',
  multi_witness: 'multi_witness',
  on_call: 'on_call',
  washington_dr: 'washington_dr',
  california_dr: 'california_dr',
} as const

export type AvailabilityRange = {
  end: string
  start: string
  weekday: number
}

export type Availability = {
  readonly duration: number
  ends_at: string
  id: string
  reporter_id: string
  starts_at: string
  readonly url: string
}

export type AttendeeRole = (typeof AttendeeRole)[keyof typeof AttendeeRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttendeeRole = {
  arbitrator: 'arbitrator',
  clerk_of_court: 'clerk_of_court',
  digital_reporter: 'digital_reporter',
  videographer: 'videographer',
  session_assistant: 'session_assistant',
  interpreter: 'interpreter',
  investigator: 'investigator',
  plaintiff_attorney: 'plaintiff_attorney',
  defendant_attorney: 'defendant_attorney',
  witness_attorney: 'witness_attorney',
  judge: 'judge',
  opposing_counsel: 'opposing_counsel',
  staff_counsel: 'staff_counsel',
  witness: 'witness',
  other: 'other',
  guardian_for_the_witness: 'guardian_for_the_witness',
  victim: 'victim',
  suspect: 'suspect',
  support_staff: 'support_staff',
  client_side: 'client_side',
  opposing_side: 'opposing_side',
  direct_examiner: 'direct_examiner',
  cross_examiner: 'cross_examiner',
  interviewer: 'interviewer',
  interviewee: 'interviewee',
  court_deputy: 'court_deputy',
  clerk: 'clerk',
  court_reporter: 'court_reporter',
} as const

export type AttendeeUser = User | null

export type AttendeePresent = boolean | null

export type AttendeeEmail = string | null

export type Attendee = {
  email?: AttendeeEmail
  id: string
  readonly is_attorney: boolean
  readonly is_attorney_who_is_our_customer: boolean
  name: string
  present?: AttendeePresent
  role: string
  user?: AttendeeUser
}

export type AsrWordSpeakerId = string | null

export type AsrWord = {
  end_time: number
  speaker_id?: AsrWordSpeakerId
  start_time: number
  word: string
}

export type AdminEventTimezone = string | null

export type AdminEventStatus =
  (typeof AdminEventStatus)[keyof typeof AdminEventStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEventStatus = {
  waiting_for_details: 'waiting_for_details',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  processing: 'processing',
  past: 'past',
  cancelled: 'cancelled',
  split: 'split',
  data_entry: 'data_entry',
  pending_onboarding: 'pending_onboarding',
} as const

export type AdminEventResult = EventResult | null

export type AdminEventRequiredReporterExperienceLevelOverride = number | null

export type AdminEventRequiredReporterExperienceLevel = number | null

export type AdminEventReporterSilo = ReporterSilo | null

export type AdminEventReporter = ReporterBase | null

export type AdminEventRelatedEventsType = 'back-to-back' | 'hearing' | null

export type AdminEventMeetingId = string | null

export type AdminEventLivestreamUrl = string | null

export type AdminEventLivestreamKey = string | null

export type AdminEventIsZoombotRecordingEnabled = boolean | null

export type AdminEventIsReporterEligible = boolean | null

export type AdminEventGeneralStatus =
  (typeof AdminEventGeneralStatus)[keyof typeof AdminEventGeneralStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEventGeneralStatus = {
  available: 'available',
  unavailable: 'unavailable',
  booked: 'booked',
  past: 'past',
  waiting: 'waiting',
  cancelled: 'cancelled',
} as const

export type AdminEventFirstRefusalHolder = ReporterBase | null

export type AdminEventFirstRefusalHold = FirstRefusalHold | null

export type AdminEventEventLevelAtBooking = number | null

export type AdminEventEventLevel = number | null

export type AdminEventErrataPolicy = ErrataPolicy | null

export type AdminEventCourtReporterSource = CourtReporterSource | null

export type AdminEventClaimNumber = string | null

export type AdminEventBundle = EventBundle | null

export type AdminEventBooking = Booking | null

export type AdminEvent = {
  attendees: Attendee[]
  readonly attorney_emails: readonly string[]
  readonly available_reporters_url: string
  booking?: AdminEventBooking
  readonly booking_url: string
  bookings: Booking[]
  bundle?: AdminEventBundle
  can_order_for_oc: boolean
  case: Case
  claim_number?: AdminEventClaimNumber
  readonly cna_transcript_orders_enabled: boolean
  readonly computed_required_reporter_experience_level: number
  court_reporter_source?: AdminEventCourtReporterSource
  created: string
  datetime: string
  duration: number
  readonly end_datetime: string
  readonly end_url: string
  errata_policy?: AdminEventErrataPolicy
  event_level?: AdminEventEventLevel
  event_level_at_booking?: AdminEventEventLevelAtBooking
  readonly exhibits_url: string
  readonly feedback_url: string
  first_refusal_hold?: AdminEventFirstRefusalHold
  first_refusal_holder?: AdminEventFirstRefusalHolder
  general_status: AdminEventGeneralStatus
  readonly has_related_events: boolean
  id: string
  readonly is_cancelable: boolean
  readonly is_cancelled: boolean
  is_deposition_in_aid: boolean
  readonly is_ended: boolean
  readonly is_ongoing: boolean
  is_reporter_eligible?: AdminEventIsReporterEligible
  readonly is_transcript_order_required: boolean
  readonly is_upcoming: boolean
  is_waiting_for_reporter_feedback: boolean
  is_zoombot_recording_enabled?: AdminEventIsZoombotRecordingEnabled
  readonly join_info_url: string
  livestream_key?: AdminEventLivestreamKey
  livestream_url?: AdminEventLivestreamUrl
  readonly low_confidence_words_url: string
  readonly media_resources_url: string
  meeting_id?: AdminEventMeetingId
  name: string
  readonly presign_id_screenshot_upload_url: string
  recording: Recording
  related_events_type?: AdminEventRelatedEventsType
  readonly related_events_url: string
  reporter?: AdminEventReporter
  reporter_silo?: AdminEventReporterSilo
  required_badges?: Badge[]
  required_reporter_experience_level?: AdminEventRequiredReporterExperienceLevel
  required_reporter_experience_level_override?: AdminEventRequiredReporterExperienceLevelOverride
  result?: AdminEventResult
  readonly script_data_url: string
  short_id: string
  status: AdminEventStatus
  readonly submit_feedback_url: string
  readonly submit_script_data_url: string
  team: Team
  timezone?: AdminEventTimezone
  type: EventType
  uses_external_zoom_meeting: boolean
}

/**
 * @summary Admin Events
 */
export const adminEvents = (
  params: AdminEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AdminEvent[]>> => {
  return axios.get(`/api/admins/events`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getAdminEventsQueryKey = (params: AdminEventsParams) => {
  return [`/api/admins/events`, ...(params ? [params] : [])] as const
}

export const getAdminEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: AdminEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminEventsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminEvents>>> = ({
    signal,
  }) => adminEvents(params, { signal, ...axiosOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AdminEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminEvents>>
>
export type AdminEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Admin Events
 */
export const useAdminEvents = <
  TData = Awaited<ReturnType<typeof adminEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: AdminEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminEventsQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Return the compact, additive admin calendar contract.
 * @summary Calendar Admin Events
 */
export const calendarAdminEvents = (
  params: CalendarAdminEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CalendarAdminEvent[]>> => {
  return axios.get(`/api/v2/admins/events`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getCalendarAdminEventsQueryKey = (
  params: CalendarAdminEventsParams,
) => {
  return [`/api/v2/admins/events`, ...(params ? [params] : [])] as const
}

export const getCalendarAdminEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof calendarAdminEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: CalendarAdminEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof calendarAdminEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getCalendarAdminEventsQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof calendarAdminEvents>>
  > = ({ signal }) => calendarAdminEvents(params, { signal, ...axiosOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof calendarAdminEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CalendarAdminEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof calendarAdminEvents>>
>
export type CalendarAdminEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Calendar Admin Events
 */
export const useCalendarAdminEvents = <
  TData = Awaited<ReturnType<typeof calendarAdminEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: CalendarAdminEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof calendarAdminEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCalendarAdminEventsQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Admin Event Detail
 */
export const adminEventDetail = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AdminEvent>> => {
  return axios.get(`/api/admins/events/${id}`, options)
}

export const getAdminEventDetailQueryKey = (id: string) => {
  return [`/api/admins/events/${id}`] as const
}

export const getAdminEventDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof adminEventDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminEventDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminEventDetailQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminEventDetail>>
  > = ({ signal }) => adminEventDetail(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminEventDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AdminEventDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminEventDetail>>
>
export type AdminEventDetailQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Admin Event Detail
 */
export const useAdminEventDetail = <
  TData = Awaited<ReturnType<typeof adminEventDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminEventDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminEventDetailQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Admin Related Events
 */
export const adminRelatedEvents = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AdminEvent[]>> => {
  return axios.get(`/api/admins/events/${id}/related`, options)
}

export const getAdminRelatedEventsQueryKey = (id: string) => {
  return [`/api/admins/events/${id}/related`] as const
}

export const getAdminRelatedEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminRelatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminRelatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminRelatedEventsQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminRelatedEvents>>
  > = ({ signal }) => adminRelatedEvents(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminRelatedEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AdminRelatedEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminRelatedEvents>>
>
export type AdminRelatedEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Admin Related Events
 */
export const useAdminRelatedEvents = <
  TData = Awaited<ReturnType<typeof adminRelatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminRelatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminRelatedEventsQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Admin Available Reporters
 */
export const adminAvailableReporters = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterWithAvailability[]>> => {
  return axios.get(`/api/admins/events/${id}/available-reporters`, options)
}

export const getAdminAvailableReportersQueryKey = (id: string) => {
  return [`/api/admins/events/${id}/available-reporters`] as const
}

export const getAdminAvailableReportersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAvailableReporters>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminAvailableReporters>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getAdminAvailableReportersQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminAvailableReporters>>
  > = ({ signal }) => adminAvailableReporters(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAvailableReporters>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AdminAvailableReportersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminAvailableReporters>>
>
export type AdminAvailableReportersQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Admin Available Reporters
 */
export const useAdminAvailableReporters = <
  TData = Awaited<ReturnType<typeof adminAvailableReporters>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminAvailableReporters>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminAvailableReportersQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Calendar Admin Court Reporter Events
 */
export const calendarAdminCourtReporterEvents = (
  params: CalendarAdminCourtReporterEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CalendarCourtReporterAdminEvent[]>> => {
  return axios.get(`/api/v2/admins/court-reporter-events`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getCalendarAdminCourtReporterEventsQueryKey = (
  params: CalendarAdminCourtReporterEventsParams,
) => {
  return [
    `/api/v2/admins/court-reporter-events`,
    ...(params ? [params] : []),
  ] as const
}

export const getCalendarAdminCourtReporterEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof calendarAdminCourtReporterEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: CalendarAdminCourtReporterEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof calendarAdminCourtReporterEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getCalendarAdminCourtReporterEventsQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof calendarAdminCourtReporterEvents>>
  > = ({ signal }) =>
    calendarAdminCourtReporterEvents(params, { signal, ...axiosOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof calendarAdminCourtReporterEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CalendarAdminCourtReporterEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof calendarAdminCourtReporterEvents>>
>
export type CalendarAdminCourtReporterEventsQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Calendar Admin Court Reporter Events
 */
export const useCalendarAdminCourtReporterEvents = <
  TData = Awaited<ReturnType<typeof calendarAdminCourtReporterEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: CalendarAdminCourtReporterEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof calendarAdminCourtReporterEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCalendarAdminCourtReporterEventsQueryOptions(
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Admin Court Reporters
 */
export const adminCourtReporters = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporter[]>> => {
  return axios.get(`/api/admins/court-reporters`, options)
}

export const getAdminCourtReportersQueryKey = () => {
  return [`/api/admins/court-reporters`] as const
}

export const getAdminCourtReportersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminCourtReporters>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminCourtReporters>>,
    TError,
    TData
  >
  axios?: AxiosRequestConfig
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminCourtReportersQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminCourtReporters>>
  > = ({ signal }) => adminCourtReporters({ signal, ...axiosOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminCourtReporters>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AdminCourtReportersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminCourtReporters>>
>
export type AdminCourtReportersQueryError = AxiosError<unknown>

/**
 * @summary Admin Court Reporters
 */
export const useAdminCourtReporters = <
  TData = Awaited<ReturnType<typeof adminCourtReporters>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminCourtReporters>>,
    TError,
    TData
  >
  axios?: AxiosRequestConfig
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminCourtReportersQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Book Court Reporter
 */
export const bookCourtReporter = (
  id: string,
  bookCourtReporterPayload: BookCourtReporterPayload,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/api/admins/events/${id}/court-reporter-booking`,
    bookCourtReporterPayload,
    options,
  )
}

export const getBookCourtReporterMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bookCourtReporter>>,
    TError,
    { id: string; data: BookCourtReporterPayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof bookCourtReporter>>,
  TError,
  { id: string; data: BookCourtReporterPayload },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bookCourtReporter>>,
    { id: string; data: BookCourtReporterPayload }
  > = props => {
    const { id, data } = props ?? {}

    return bookCourtReporter(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type BookCourtReporterMutationResult = NonNullable<
  Awaited<ReturnType<typeof bookCourtReporter>>
>
export type BookCourtReporterMutationBody = BookCourtReporterPayload
export type BookCourtReporterMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Book Court Reporter
 */
export const useBookCourtReporter = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bookCourtReporter>>,
    TError,
    { id: string; data: BookCourtReporterPayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof bookCourtReporter>>,
  TError,
  { id: string; data: BookCourtReporterPayload },
  TContext
> => {
  const mutationOptions = getBookCourtReporterMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Unbook Court Reporter
 */
export const unbookCourtReporter = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.delete(
    `/api/admins/events/${id}/court-reporter-booking`,
    options,
  )
}

export const getUnbookCourtReporterMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unbookCourtReporter>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof unbookCourtReporter>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unbookCourtReporter>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return unbookCourtReporter(id, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UnbookCourtReporterMutationResult = NonNullable<
  Awaited<ReturnType<typeof unbookCourtReporter>>
>

export type UnbookCourtReporterMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Unbook Court Reporter
 */
export const useUnbookCourtReporter = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unbookCourtReporter>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof unbookCourtReporter>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getUnbookCourtReporterMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Admin Court Reporter Event Detail
 */
export const adminCourtReporterEventDetail = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterAdminEventDetail>> => {
  return axios.get(`/api/admins/court-reporter-events/${id}`, options)
}

export const getAdminCourtReporterEventDetailQueryKey = (id: string) => {
  return [`/api/admins/court-reporter-events/${id}`] as const
}

export const getAdminCourtReporterEventDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof adminCourtReporterEventDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminCourtReporterEventDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getAdminCourtReporterEventDetailQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminCourtReporterEventDetail>>
  > = ({ signal }) =>
    adminCourtReporterEventDetail(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminCourtReporterEventDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AdminCourtReporterEventDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminCourtReporterEventDetail>>
>
export type AdminCourtReporterEventDetailQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Admin Court Reporter Event Detail
 */
export const useAdminCourtReporterEventDetail = <
  TData = Awaited<ReturnType<typeof adminCourtReporterEventDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminCourtReporterEventDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminCourtReporterEventDetailQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Admin Court Reporter Event Deliverables
 */
export const adminCourtReporterEventDeliverables = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterDeliverable[]>> => {
  return axios.get(
    `/api/admins/court-reporter-events/${id}/deliverables`,
    options,
  )
}

export const getAdminCourtReporterEventDeliverablesQueryKey = (id: string) => {
  return [`/api/admins/court-reporter-events/${id}/deliverables`] as const
}

export const getAdminCourtReporterEventDeliverablesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminCourtReporterEventDeliverables>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminCourtReporterEventDeliverables>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getAdminCourtReporterEventDeliverablesQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminCourtReporterEventDeliverables>>
  > = ({ signal }) =>
    adminCourtReporterEventDeliverables(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminCourtReporterEventDeliverables>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AdminCourtReporterEventDeliverablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminCourtReporterEventDeliverables>>
>
export type AdminCourtReporterEventDeliverablesQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Admin Court Reporter Event Deliverables
 */
export const useAdminCourtReporterEventDeliverables = <
  TData = Awaited<ReturnType<typeof adminCourtReporterEventDeliverables>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminCourtReporterEventDeliverables>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminCourtReporterEventDeliverablesQueryOptions(
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Save Admin Court Reporter Event Deliverable
 */
export const saveAdminCourtReporterEventDeliverable = (
  id: string,
  saveCourtReporterDeliverablePayload: SaveCourtReporterDeliverablePayload,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterDeliverable>> => {
  return axios.post(
    `/api/admins/court-reporter-events/${id}/deliverables`,
    saveCourtReporterDeliverablePayload,
    options,
  )
}

export const getSaveAdminCourtReporterEventDeliverableMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAdminCourtReporterEventDeliverable>>,
    TError,
    { id: string; data: SaveCourtReporterDeliverablePayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveAdminCourtReporterEventDeliverable>>,
  TError,
  { id: string; data: SaveCourtReporterDeliverablePayload },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveAdminCourtReporterEventDeliverable>>,
    { id: string; data: SaveCourtReporterDeliverablePayload }
  > = props => {
    const { id, data } = props ?? {}

    return saveAdminCourtReporterEventDeliverable(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SaveAdminCourtReporterEventDeliverableMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveAdminCourtReporterEventDeliverable>>
>
export type SaveAdminCourtReporterEventDeliverableMutationBody =
  SaveCourtReporterDeliverablePayload
export type SaveAdminCourtReporterEventDeliverableMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Save Admin Court Reporter Event Deliverable
 */
export const useSaveAdminCourtReporterEventDeliverable = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAdminCourtReporterEventDeliverable>>,
    TError,
    { id: string; data: SaveCourtReporterDeliverablePayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof saveAdminCourtReporterEventDeliverable>>,
  TError,
  { id: string; data: SaveCourtReporterDeliverablePayload },
  TContext
> => {
  const mutationOptions =
    getSaveAdminCourtReporterEventDeliverableMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Presign Admin Court Reporter Event Deliverable
 */
export const presignAdminCourtReporterEventDeliverable = (
  id: string,
  presignCourtReporterDeliverablePayload: PresignCourtReporterDeliverablePayload,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterDeliverableUploadUrl>> => {
  return axios.post(
    `/api/admins/court-reporter-events/${id}/deliverables/upload-url`,
    presignCourtReporterDeliverablePayload,
    options,
  )
}

export const getPresignAdminCourtReporterEventDeliverableMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof presignAdminCourtReporterEventDeliverable>>,
    TError,
    { id: string; data: PresignCourtReporterDeliverablePayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof presignAdminCourtReporterEventDeliverable>>,
  TError,
  { id: string; data: PresignCourtReporterDeliverablePayload },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof presignAdminCourtReporterEventDeliverable>>,
    { id: string; data: PresignCourtReporterDeliverablePayload }
  > = props => {
    const { id, data } = props ?? {}

    return presignAdminCourtReporterEventDeliverable(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PresignAdminCourtReporterEventDeliverableMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof presignAdminCourtReporterEventDeliverable>>
  >
export type PresignAdminCourtReporterEventDeliverableMutationBody =
  PresignCourtReporterDeliverablePayload
export type PresignAdminCourtReporterEventDeliverableMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Presign Admin Court Reporter Event Deliverable
 */
export const usePresignAdminCourtReporterEventDeliverable = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof presignAdminCourtReporterEventDeliverable>>,
    TError,
    { id: string; data: PresignCourtReporterDeliverablePayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof presignAdminCourtReporterEventDeliverable>>,
  TError,
  { id: string; data: PresignCourtReporterDeliverablePayload },
  TContext
> => {
  const mutationOptions =
    getPresignAdminCourtReporterEventDeliverableMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Remove Admin Court Reporter Event Deliverable
 */
export const removeAdminCourtReporterEventDeliverable = (
  id: string,
  deliverableId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `/api/admins/court-reporter-events/${id}/deliverables/${deliverableId}`,
    options,
  )
}

export const getRemoveAdminCourtReporterEventDeliverableMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAdminCourtReporterEventDeliverable>>,
    TError,
    { id: string; deliverableId: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeAdminCourtReporterEventDeliverable>>,
  TError,
  { id: string; deliverableId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeAdminCourtReporterEventDeliverable>>,
    { id: string; deliverableId: string }
  > = props => {
    const { id, deliverableId } = props ?? {}

    return removeAdminCourtReporterEventDeliverable(
      id,
      deliverableId,
      axiosOptions,
    )
  }

  return { mutationFn, ...mutationOptions }
}

export type RemoveAdminCourtReporterEventDeliverableMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeAdminCourtReporterEventDeliverable>>
  >

export type RemoveAdminCourtReporterEventDeliverableMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Remove Admin Court Reporter Event Deliverable
 */
export const useRemoveAdminCourtReporterEventDeliverable = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAdminCourtReporterEventDeliverable>>,
    TError,
    { id: string; deliverableId: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof removeAdminCourtReporterEventDeliverable>>,
  TError,
  { id: string; deliverableId: string },
  TContext
> => {
  const mutationOptions =
    getRemoveAdminCourtReporterEventDeliverableMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Events
 */
export const events = (
  reporterId: string,
  params: EventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterEvent[]>> => {
  return axios.get(`/api/reporters/${reporterId}/events`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getEventsQueryKey = (reporterId: string, params: EventsParams) => {
  return [
    `/api/reporters/${reporterId}/events`,
    ...(params ? [params] : []),
  ] as const
}

export const getEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof events>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  params: EventsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getEventsQueryKey(reporterId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof events>>> = ({
    signal,
  }) => events(reporterId, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!reporterId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData> & {
    queryKey: QueryKey
  }
}

export type EventsQueryResult = NonNullable<Awaited<ReturnType<typeof events>>>
export type EventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Events
 */
export const useEvents = <
  TData = Awaited<ReturnType<typeof events>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  params: EventsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getEventsQueryOptions(reporterId, params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Return the compact, additive reporter calendar contract.
 * @summary Calendar Events
 */
export const calendarEvents = (
  reporterId: string,
  params: CalendarEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CalendarReporterEvent[]>> => {
  return axios.get(`/api/v2/reporters/${reporterId}/events`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getCalendarEventsQueryKey = (
  reporterId: string,
  params: CalendarEventsParams,
) => {
  return [
    `/api/v2/reporters/${reporterId}/events`,
    ...(params ? [params] : []),
  ] as const
}

export const getCalendarEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof calendarEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  params: CalendarEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof calendarEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getCalendarEventsQueryKey(reporterId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof calendarEvents>>> = ({
    signal,
  }) => calendarEvents(reporterId, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!reporterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof calendarEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CalendarEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof calendarEvents>>
>
export type CalendarEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Calendar Events
 */
export const useCalendarEvents = <
  TData = Awaited<ReturnType<typeof calendarEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  params: CalendarEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof calendarEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCalendarEventsQueryOptions(
    reporterId,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Waiting Events
 */
export const waitingEvents = (
  reporterId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterEvent[]>> => {
  return axios.get(`/api/reporters/${reporterId}/events/waiting`, options)
}

export const getWaitingEventsQueryKey = (reporterId: string) => {
  return [`/api/reporters/${reporterId}/events/waiting`] as const
}

export const getWaitingEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof waitingEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof waitingEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getWaitingEventsQueryKey(reporterId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof waitingEvents>>> = ({
    signal,
  }) => waitingEvents(reporterId, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!reporterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof waitingEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type WaitingEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof waitingEvents>>
>
export type WaitingEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Waiting Events
 */
export const useWaitingEvents = <
  TData = Awaited<ReturnType<typeof waitingEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof waitingEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getWaitingEventsQueryOptions(reporterId, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Available Events
 */
export const availableEvents = (
  reporterId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterEvent[]>> => {
  return axios.get(`/api/reporters/${reporterId}/events/available`, options)
}

export const getAvailableEventsQueryKey = (reporterId: string) => {
  return [`/api/reporters/${reporterId}/events/available`] as const
}

export const getAvailableEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof availableEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getAvailableEventsQueryKey(reporterId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof availableEvents>>> = ({
    signal,
  }) => availableEvents(reporterId, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!reporterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AvailableEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableEvents>>
>
export type AvailableEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Available Events
 */
export const useAvailableEvents = <
  TData = Awaited<ReturnType<typeof availableEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAvailableEventsQueryOptions(reporterId, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Event Detail
 */
export const eventDetail = (
  reporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterEvent>> => {
  return axios.get(`/api/reporters/${reporterId}/events/${id}`, options)
}

export const getEventDetailQueryKey = (reporterId: string, id: string) => {
  return [`/api/reporters/${reporterId}/events/${id}`] as const
}

export const getEventDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof eventDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eventDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getEventDetailQueryKey(reporterId, id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof eventDetail>>> = ({
    signal,
  }) => eventDetail(reporterId, id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!(reporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof eventDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type EventDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof eventDetail>>
>
export type EventDetailQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Event Detail
 */
export const useEventDetail = <
  TData = Awaited<ReturnType<typeof eventDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eventDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getEventDetailQueryOptions(reporterId, id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Related Events
 */
export const relatedEvents = (
  reporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterEvent[]>> => {
  return axios.get(`/api/reporters/${reporterId}/events/${id}/related`, options)
}

export const getRelatedEventsQueryKey = (reporterId: string, id: string) => {
  return [`/api/reporters/${reporterId}/events/${id}/related`] as const
}

export const getRelatedEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof relatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof relatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getRelatedEventsQueryKey(reporterId, id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatedEvents>>> = ({
    signal,
  }) => relatedEvents(reporterId, id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!(reporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof relatedEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type RelatedEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatedEvents>>
>
export type RelatedEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Related Events
 */
export const useRelatedEvents = <
  TData = Awaited<ReturnType<typeof relatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof relatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getRelatedEventsQueryOptions(reporterId, id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Available Related Events
 */
export const availableRelatedEvents = (
  reporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterEvent[]>> => {
  return axios.get(
    `/api/reporters/${reporterId}/events/${id}/related/available`,
    options,
  )
}

export const getAvailableRelatedEventsQueryKey = (
  reporterId: string,
  id: string,
) => {
  return [
    `/api/reporters/${reporterId}/events/${id}/related/available`,
  ] as const
}

export const getAvailableRelatedEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof availableRelatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableRelatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getAvailableRelatedEventsQueryKey(reporterId, id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableRelatedEvents>>
  > = ({ signal }) =>
    availableRelatedEvents(reporterId, id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!(reporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof availableRelatedEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AvailableRelatedEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableRelatedEvents>>
>
export type AvailableRelatedEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Available Related Events
 */
export const useAvailableRelatedEvents = <
  TData = Awaited<ReturnType<typeof availableRelatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof availableRelatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAvailableRelatedEventsQueryOptions(
    reporterId,
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Booked Related Events
 */
export const bookedRelatedEvents = (
  reporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterEvent[]>> => {
  return axios.get(
    `/api/reporters/${reporterId}/events/${id}/related/booked`,
    options,
  )
}

export const getBookedRelatedEventsQueryKey = (
  reporterId: string,
  id: string,
) => {
  return [`/api/reporters/${reporterId}/events/${id}/related/booked`] as const
}

export const getBookedRelatedEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof bookedRelatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof bookedRelatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getBookedRelatedEventsQueryKey(reporterId, id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bookedRelatedEvents>>
  > = ({ signal }) =>
    bookedRelatedEvents(reporterId, id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!(reporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bookedRelatedEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type BookedRelatedEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof bookedRelatedEvents>>
>
export type BookedRelatedEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Booked Related Events
 */
export const useBookedRelatedEvents = <
  TData = Awaited<ReturnType<typeof bookedRelatedEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof bookedRelatedEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBookedRelatedEventsQueryOptions(
    reporterId,
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Reporter Weekly Availability
 */
export const reporterWeeklyAvailability = (
  id: string,
  params: ReporterWeeklyAvailabilityParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WeeklyAvailability>> => {
  return axios.get(`/api/reporters/${id}/availability`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getReporterWeeklyAvailabilityQueryKey = (
  id: string,
  params: ReporterWeeklyAvailabilityParams,
) => {
  return [
    `/api/reporters/${id}/availability`,
    ...(params ? [params] : []),
  ] as const
}

export const getReporterWeeklyAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof reporterWeeklyAvailability>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: ReporterWeeklyAvailabilityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reporterWeeklyAvailability>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getReporterWeeklyAvailabilityQueryKey(id, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reporterWeeklyAvailability>>
  > = ({ signal }) =>
    reporterWeeklyAvailability(id, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof reporterWeeklyAvailability>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ReporterWeeklyAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof reporterWeeklyAvailability>>
>
export type ReporterWeeklyAvailabilityQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Reporter Weekly Availability
 */
export const useReporterWeeklyAvailability = <
  TData = Awaited<ReturnType<typeof reporterWeeklyAvailability>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: ReporterWeeklyAvailabilityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reporterWeeklyAvailability>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getReporterWeeklyAvailabilityQueryOptions(
    id,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Set Reporter Weekly Availability
 */
export const setReporterWeeklyAvailability = (
  id: string,
  setWeeklyAvailability: SetWeeklyAvailability,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WeeklyAvailability>> => {
  return axios.put(
    `/api/reporters/${id}/availability`,
    setWeeklyAvailability,
    options,
  )
}

export const getSetReporterWeeklyAvailabilityMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setReporterWeeklyAvailability>>,
    TError,
    { id: string; data: SetWeeklyAvailability },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof setReporterWeeklyAvailability>>,
  TError,
  { id: string; data: SetWeeklyAvailability },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setReporterWeeklyAvailability>>,
    { id: string; data: SetWeeklyAvailability }
  > = props => {
    const { id, data } = props ?? {}

    return setReporterWeeklyAvailability(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SetReporterWeeklyAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof setReporterWeeklyAvailability>>
>
export type SetReporterWeeklyAvailabilityMutationBody = SetWeeklyAvailability
export type SetReporterWeeklyAvailabilityMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Set Reporter Weekly Availability
 */
export const useSetReporterWeeklyAvailability = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setReporterWeeklyAvailability>>,
    TError,
    { id: string; data: SetWeeklyAvailability },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof setReporterWeeklyAvailability>>,
  TError,
  { id: string; data: SetWeeklyAvailability },
  TContext
> => {
  const mutationOptions =
    getSetReporterWeeklyAvailabilityMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Reporters
 */
export const reporters = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReporterBase[]>> => {
  return axios.get(`/api/reporters`, options)
}

export const getReportersQueryKey = () => {
  return [`/api/reporters`] as const
}

export const getReportersQueryOptions = <
  TData = Awaited<ReturnType<typeof reporters>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof reporters>>, TError, TData>
  axios?: AxiosRequestConfig
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getReportersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reporters>>> = ({
    signal,
  }) => reporters({ signal, ...axiosOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reporters>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ReportersQueryResult = NonNullable<
  Awaited<ReturnType<typeof reporters>>
>
export type ReportersQueryError = AxiosError<unknown>

/**
 * @summary Reporters
 */
export const useReporters = <
  TData = Awaited<ReturnType<typeof reporters>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof reporters>>, TError, TData>
  axios?: AxiosRequestConfig
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getReportersQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Reporter
 */
export const createReporter = (
  createReporter: CreateReporter,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Reporter>> => {
  return axios.post(`/api/reporters`, createReporter, options)
}

export const getCreateReporterMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReporter>>,
    TError,
    { data: CreateReporter },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReporter>>,
  TError,
  { data: CreateReporter },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReporter>>,
    { data: CreateReporter }
  > = props => {
    const { data } = props ?? {}

    return createReporter(data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateReporterMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReporter>>
>
export type CreateReporterMutationBody = CreateReporter
export type CreateReporterMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Create Reporter
 */
export const useCreateReporter = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReporter>>,
    TError,
    { data: CreateReporter },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof createReporter>>,
  TError,
  { data: CreateReporter },
  TContext
> => {
  const mutationOptions = getCreateReporterMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Reporter Detail
 */
export const reporterDetail = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Reporter>> => {
  return axios.get(`/api/reporters/${id}`, options)
}

export const getReporterDetailQueryKey = (id: string) => {
  return [`/api/reporters/${id}`] as const
}

export const getReporterDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof reporterDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reporterDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getReporterDetailQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reporterDetail>>> = ({
    signal,
  }) => reporterDetail(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof reporterDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ReporterDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof reporterDetail>>
>
export type ReporterDetailQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Reporter Detail
 */
export const useReporterDetail = <
  TData = Awaited<ReturnType<typeof reporterDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reporterDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getReporterDetailQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Reporter
 */
export const updateReporter = (
  id: string,
  updateReporterInput: UpdateReporterInput,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Reporter>> => {
  return axios.put(`/api/reporters/${id}`, updateReporterInput, options)
}

export const getUpdateReporterMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReporter>>,
    TError,
    { id: string; data: UpdateReporterInput },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReporter>>,
  TError,
  { id: string; data: UpdateReporterInput },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReporter>>,
    { id: string; data: UpdateReporterInput }
  > = props => {
    const { id, data } = props ?? {}

    return updateReporter(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateReporterMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReporter>>
>
export type UpdateReporterMutationBody = UpdateReporterInput
export type UpdateReporterMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Update Reporter
 */
export const useUpdateReporter = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReporter>>,
    TError,
    { id: string; data: UpdateReporterInput },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReporter>>,
  TError,
  { id: string; data: UpdateReporterInput },
  TContext
> => {
  const mutationOptions = getUpdateReporterMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Update Reporter Level
 */
export const updateReporterLevel = (
  id: string,
  updateLevel: UpdateLevel,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Reporter>> => {
  return axios.put(`/api/reporters/${id}/level`, updateLevel, options)
}

export const getUpdateReporterLevelMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReporterLevel>>,
    TError,
    { id: string; data: UpdateLevel },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReporterLevel>>,
  TError,
  { id: string; data: UpdateLevel },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReporterLevel>>,
    { id: string; data: UpdateLevel }
  > = props => {
    const { id, data } = props ?? {}

    return updateReporterLevel(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateReporterLevelMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReporterLevel>>
>
export type UpdateReporterLevelMutationBody = UpdateLevel
export type UpdateReporterLevelMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Update Reporter Level
 */
export const useUpdateReporterLevel = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReporterLevel>>,
    TError,
    { id: string; data: UpdateLevel },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReporterLevel>>,
  TError,
  { id: string; data: UpdateLevel },
  TContext
> => {
  const mutationOptions = getUpdateReporterLevelMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Update Reporter Stripe Account
 */
export const updateReporterStripeAccount = (
  id: string,
  updateStripeAccount: UpdateStripeAccount,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Reporter>> => {
  return axios.put(
    `/api/reporters/${id}/stripe_account`,
    updateStripeAccount,
    options,
  )
}

export const getUpdateReporterStripeAccountMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReporterStripeAccount>>,
    TError,
    { id: string; data: UpdateStripeAccount },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReporterStripeAccount>>,
  TError,
  { id: string; data: UpdateStripeAccount },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReporterStripeAccount>>,
    { id: string; data: UpdateStripeAccount }
  > = props => {
    const { id, data } = props ?? {}

    return updateReporterStripeAccount(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateReporterStripeAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReporterStripeAccount>>
>
export type UpdateReporterStripeAccountMutationBody = UpdateStripeAccount
export type UpdateReporterStripeAccountMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Update Reporter Stripe Account
 */
export const useUpdateReporterStripeAccount = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReporterStripeAccount>>,
    TError,
    { id: string; data: UpdateStripeAccount },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReporterStripeAccount>>,
  TError,
  { id: string; data: UpdateStripeAccount },
  TContext
> => {
  const mutationOptions = getUpdateReporterStripeAccountMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Deactivate Reporter
 */
export const deactivateReporter = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Reporter>> => {
  return axios.put(`/api/reporters/${id}/deactivate`, undefined, options)
}

export const getDeactivateReporterMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateReporter>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateReporter>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateReporter>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return deactivateReporter(id, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeactivateReporterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateReporter>>
>

export type DeactivateReporterMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Deactivate Reporter
 */
export const useDeactivateReporter = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateReporter>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof deactivateReporter>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeactivateReporterMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Reactivate Reporter
 */
export const reactivateReporter = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Reporter>> => {
  return axios.put(`/api/reporters/${id}/reactivate`, undefined, options)
}

export const getReactivateReporterMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivateReporter>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof reactivateReporter>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reactivateReporter>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return reactivateReporter(id, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ReactivateReporterMutationResult = NonNullable<
  Awaited<ReturnType<typeof reactivateReporter>>
>

export type ReactivateReporterMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Reactivate Reporter
 */
export const useReactivateReporter = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivateReporter>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof reactivateReporter>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getReactivateReporterMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Presign Commission License Upload
 */
export const presignCommissionLicenseUpload = (
  id: string,
  params: PresignCommissionLicenseUploadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PresignedS3PostResultWithPreview>> => {
  return axios.get(`/api/reporters/${id}/presign-commission-license`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getPresignCommissionLicenseUploadQueryKey = (
  id: string,
  params: PresignCommissionLicenseUploadParams,
) => {
  return [
    `/api/reporters/${id}/presign-commission-license`,
    ...(params ? [params] : []),
  ] as const
}

export const getPresignCommissionLicenseUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof presignCommissionLicenseUpload>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: PresignCommissionLicenseUploadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof presignCommissionLicenseUpload>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getPresignCommissionLicenseUploadQueryKey(id, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof presignCommissionLicenseUpload>>
  > = ({ signal }) =>
    presignCommissionLicenseUpload(id, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof presignCommissionLicenseUpload>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type PresignCommissionLicenseUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof presignCommissionLicenseUpload>>
>
export type PresignCommissionLicenseUploadQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Presign Commission License Upload
 */
export const usePresignCommissionLicenseUpload = <
  TData = Awaited<ReturnType<typeof presignCommissionLicenseUpload>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: PresignCommissionLicenseUploadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof presignCommissionLicenseUpload>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPresignCommissionLicenseUploadQueryOptions(
    id,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Presign Certificate Upload
 */
export const presignCertificateUpload = (
  id: string,
  params: PresignCertificateUploadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PresignedS3PostResultWithPreview>> => {
  return axios.get(`/api/reporters/${id}/presign-certificate`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getPresignCertificateUploadQueryKey = (
  id: string,
  params: PresignCertificateUploadParams,
) => {
  return [
    `/api/reporters/${id}/presign-certificate`,
    ...(params ? [params] : []),
  ] as const
}

export const getPresignCertificateUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof presignCertificateUpload>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: PresignCertificateUploadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof presignCertificateUpload>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getPresignCertificateUploadQueryKey(id, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof presignCertificateUpload>>
  > = ({ signal }) =>
    presignCertificateUpload(id, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof presignCertificateUpload>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type PresignCertificateUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof presignCertificateUpload>>
>
export type PresignCertificateUploadQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Presign Certificate Upload
 */
export const usePresignCertificateUpload = <
  TData = Awaited<ReturnType<typeof presignCertificateUpload>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: PresignCertificateUploadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof presignCertificateUpload>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPresignCertificateUploadQueryOptions(
    id,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Resend Welcome Email
 */
export const resendWelcomeEmail = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/api/reporters/${id}/resend-welcome-email`,
    undefined,
    options,
  )
}

export const getResendWelcomeEmailMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendWelcomeEmail>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendWelcomeEmail>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendWelcomeEmail>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return resendWelcomeEmail(id, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ResendWelcomeEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendWelcomeEmail>>
>

export type ResendWelcomeEmailMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Resend Welcome Email
 */
export const useResendWelcomeEmail = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendWelcomeEmail>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof resendWelcomeEmail>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getResendWelcomeEmailMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Resend Verification Email
 */
export const resendVerificationEmail = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/api/reporters/${id}/resend-verification-email`,
    undefined,
    options,
  )
}

export const getResendVerificationEmailMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendVerificationEmail>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendVerificationEmail>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendVerificationEmail>>,
    { id: string }
  > = props => {
    const { id } = props ?? {}

    return resendVerificationEmail(id, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ResendVerificationEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendVerificationEmail>>
>

export type ResendVerificationEmailMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Resend Verification Email
 */
export const useResendVerificationEmail = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendVerificationEmail>>,
    TError,
    { id: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof resendVerificationEmail>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getResendVerificationEmailMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Reporter Feedback
 */
export const getReporterFeedback = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.get(`/api/events/${id}/reporter-feedback`, options)
}

export const getGetReporterFeedbackQueryKey = (id: string) => {
  return [`/api/events/${id}/reporter-feedback`] as const
}

export const getGetReporterFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getReporterFeedback>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReporterFeedback>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReporterFeedbackQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReporterFeedback>>
  > = ({ signal }) => getReporterFeedback(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReporterFeedback>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetReporterFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReporterFeedback>>
>
export type GetReporterFeedbackQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Reporter Feedback
 */
export const useGetReporterFeedback = <
  TData = Awaited<ReturnType<typeof getReporterFeedback>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReporterFeedback>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetReporterFeedbackQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Save Reporter Feedback
 */
export const saveReporterFeedback = (
  id: string,
  saveReporterFeedbackBody: unknown,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.put(
    `/api/events/${id}/reporter-feedback`,
    saveReporterFeedbackBody,
    options,
  )
}

export const getSaveReporterFeedbackMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveReporterFeedback>>,
    TError,
    { id: string; data: unknown },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveReporterFeedback>>,
  TError,
  { id: string; data: unknown },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveReporterFeedback>>,
    { id: string; data: unknown }
  > = props => {
    const { id, data } = props ?? {}

    return saveReporterFeedback(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SaveReporterFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveReporterFeedback>>
>
export type SaveReporterFeedbackMutationBody = unknown
export type SaveReporterFeedbackMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Save Reporter Feedback
 */
export const useSaveReporterFeedback = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveReporterFeedback>>,
    TError,
    { id: string; data: unknown },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof saveReporterFeedback>>,
  TError,
  { id: string; data: unknown },
  TContext
> => {
  const mutationOptions = getSaveReporterFeedbackMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Submit Reporter Feedback
 */
export const submitReporterFeedback = (
  id: string,
  reporterFeedback: ReporterFeedback,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/api/events/${id}/reporter-feedback/submit`,
    reporterFeedback,
    options,
  )
}

export const getSubmitReporterFeedbackMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitReporterFeedback>>,
    TError,
    { id: string; data: ReporterFeedback },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitReporterFeedback>>,
  TError,
  { id: string; data: ReporterFeedback },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitReporterFeedback>>,
    { id: string; data: ReporterFeedback }
  > = props => {
    const { id, data } = props ?? {}

    return submitReporterFeedback(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SubmitReporterFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitReporterFeedback>>
>
export type SubmitReporterFeedbackMutationBody = ReporterFeedback
export type SubmitReporterFeedbackMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Submit Reporter Feedback
 */
export const useSubmitReporterFeedback = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitReporterFeedback>>,
    TError,
    { id: string; data: ReporterFeedback },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof submitReporterFeedback>>,
  TError,
  { id: string; data: ReporterFeedback },
  TContext
> => {
  const mutationOptions = getSubmitReporterFeedbackMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Presign Id Screenshot Upload
 */
export const presignIdScreenshotUpload = (
  id: string,
  params: PresignIdScreenshotUploadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PresignedS3PostResultWithPreview>> => {
  return axios.get(
    `/api/events/${id}/reporter-feedback/presign-id-screenshot`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  )
}

export const getPresignIdScreenshotUploadQueryKey = (
  id: string,
  params: PresignIdScreenshotUploadParams,
) => {
  return [
    `/api/events/${id}/reporter-feedback/presign-id-screenshot`,
    ...(params ? [params] : []),
  ] as const
}

export const getPresignIdScreenshotUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof presignIdScreenshotUpload>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: PresignIdScreenshotUploadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof presignIdScreenshotUpload>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getPresignIdScreenshotUploadQueryKey(id, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof presignIdScreenshotUpload>>
  > = ({ signal }) =>
    presignIdScreenshotUpload(id, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof presignIdScreenshotUpload>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type PresignIdScreenshotUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof presignIdScreenshotUpload>>
>
export type PresignIdScreenshotUploadQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Presign Id Screenshot Upload
 */
export const usePresignIdScreenshotUpload = <
  TData = Awaited<ReturnType<typeof presignIdScreenshotUpload>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  params: PresignIdScreenshotUploadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof presignIdScreenshotUpload>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPresignIdScreenshotUploadQueryOptions(
    id,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Script Data
 */
export const getScriptData = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ScriptDataObjectV2Output>> => {
  return axios.get(`/api/events/${id}/script-data`, options)
}

export const getGetScriptDataQueryKey = (id: string) => {
  return [`/api/events/${id}/script-data`] as const
}

export const getGetScriptDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getScriptData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScriptData>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetScriptDataQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScriptData>>> = ({
    signal,
  }) => getScriptData(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getScriptData>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetScriptDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getScriptData>>
>
export type GetScriptDataQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Script Data
 */
export const useGetScriptData = <
  TData = Awaited<ReturnType<typeof getScriptData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScriptData>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetScriptDataQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Save Script Data
 */
export const saveScriptData = (
  id: string,
  scriptDataObjectV2Input: ScriptDataObjectV2Input,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ScriptDataObjectV2Output>> => {
  return axios.post(
    `/api/events/${id}/script-data`,
    scriptDataObjectV2Input,
    options,
  )
}

export const getSaveScriptDataMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveScriptData>>,
    TError,
    { id: string; data: ScriptDataObjectV2Input },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveScriptData>>,
  TError,
  { id: string; data: ScriptDataObjectV2Input },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveScriptData>>,
    { id: string; data: ScriptDataObjectV2Input }
  > = props => {
    const { id, data } = props ?? {}

    return saveScriptData(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SaveScriptDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveScriptData>>
>
export type SaveScriptDataMutationBody = ScriptDataObjectV2Input
export type SaveScriptDataMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Save Script Data
 */
export const useSaveScriptData = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveScriptData>>,
    TError,
    { id: string; data: ScriptDataObjectV2Input },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof saveScriptData>>,
  TError,
  { id: string; data: ScriptDataObjectV2Input },
  TContext
> => {
  const mutationOptions = getSaveScriptDataMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Submit Script Data
 */
export const submitScriptData = (
  id: string,
  scriptDataObjectV2Input: ScriptDataObjectV2Input,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ScriptDataObjectV2Output>> => {
  return axios.post(
    `/api/events/${id}/script-data/submit`,
    scriptDataObjectV2Input,
    options,
  )
}

export const getSubmitScriptDataMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitScriptData>>,
    TError,
    { id: string; data: ScriptDataObjectV2Input },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitScriptData>>,
  TError,
  { id: string; data: ScriptDataObjectV2Input },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitScriptData>>,
    { id: string; data: ScriptDataObjectV2Input }
  > = props => {
    const { id, data } = props ?? {}

    return submitScriptData(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SubmitScriptDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitScriptData>>
>
export type SubmitScriptDataMutationBody = ScriptDataObjectV2Input
export type SubmitScriptDataMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Submit Script Data
 */
export const useSubmitScriptData = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitScriptData>>,
    TError,
    { id: string; data: ScriptDataObjectV2Input },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof submitScriptData>>,
  TError,
  { id: string; data: ScriptDataObjectV2Input },
  TContext
> => {
  const mutationOptions = getSubmitScriptDataMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Exhibits
 */
export const getExhibits = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Exhibit[]>> => {
  return axios.get(`/api/events/${id}/exhibits`, options)
}

export const getGetExhibitsQueryKey = (id: string) => {
  return [`/api/events/${id}/exhibits`] as const
}

export const getGetExhibitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getExhibits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExhibits>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetExhibitsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExhibits>>> = ({
    signal,
  }) => getExhibits(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExhibits>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetExhibitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExhibits>>
>
export type GetExhibitsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Exhibits
 */
export const useGetExhibits = <
  TData = Awaited<ReturnType<typeof getExhibits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExhibits>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetExhibitsQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Join Info
 */
export const getJoinInfo = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<JoinInfo>> => {
  return axios.get(`/api/events/${id}/join-info`, options)
}

export const getGetJoinInfoQueryKey = (id: string) => {
  return [`/api/events/${id}/join-info`] as const
}

export const getGetJoinInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getJoinInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJoinInfo>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetJoinInfoQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJoinInfo>>> = ({
    signal,
  }) => getJoinInfo(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJoinInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetJoinInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJoinInfo>>
>
export type GetJoinInfoQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Join Info
 */
export const useGetJoinInfo = <
  TData = Awaited<ReturnType<typeof getJoinInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJoinInfo>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJoinInfoQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Media Resources
 */
export const getMediaResources = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaResource[]>> => {
  return axios.get(`/api/events/${id}/media-resources`, options)
}

export const getGetMediaResourcesQueryKey = (id: string) => {
  return [`/api/events/${id}/media-resources`] as const
}

export const getGetMediaResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMediaResources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMediaResources>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMediaResourcesQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMediaResources>>
  > = ({ signal }) => getMediaResources(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMediaResources>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetMediaResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMediaResources>>
>
export type GetMediaResourcesQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Media Resources
 */
export const useGetMediaResources = <
  TData = Awaited<ReturnType<typeof getMediaResources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMediaResources>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMediaResourcesQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Zoombot Status
 */
export const getZoombotStatus = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.get(`/api/events/${id}/zoombot-status`, options)
}

export const getGetZoombotStatusQueryKey = (id: string) => {
  return [`/api/events/${id}/zoombot-status`] as const
}

export const getGetZoombotStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getZoombotStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getZoombotStatus>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetZoombotStatusQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getZoombotStatus>>
  > = ({ signal }) => getZoombotStatus(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getZoombotStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetZoombotStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getZoombotStatus>>
>
export type GetZoombotStatusQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Zoombot Status
 */
export const useGetZoombotStatus = <
  TData = Awaited<ReturnType<typeof getZoombotStatus>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getZoombotStatus>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetZoombotStatusQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Set Zoombot Status
 */
export const setZoombotStatus = (
  id: string,
  updateZoombotStatus: UpdateZoombotStatus,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/api/events/${id}/zoombot-status`,
    updateZoombotStatus,
    options,
  )
}

export const getSetZoombotStatusMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setZoombotStatus>>,
    TError,
    { id: string; data: UpdateZoombotStatus },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof setZoombotStatus>>,
  TError,
  { id: string; data: UpdateZoombotStatus },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setZoombotStatus>>,
    { id: string; data: UpdateZoombotStatus }
  > = props => {
    const { id, data } = props ?? {}

    return setZoombotStatus(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SetZoombotStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof setZoombotStatus>>
>
export type SetZoombotStatusMutationBody = UpdateZoombotStatus
export type SetZoombotStatusMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Set Zoombot Status
 */
export const useSetZoombotStatus = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setZoombotStatus>>,
    TError,
    { id: string; data: UpdateZoombotStatus },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof setZoombotStatus>>,
  TError,
  { id: string; data: UpdateZoombotStatus },
  TContext
> => {
  const mutationOptions = getSetZoombotStatusMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Event Participants
 */
export const getEventParticipants = (
  eventId: string,
  params?: GetEventParticipantsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EventParticipant[]>> => {
  return axios.get(`/api/events/${eventId}/participants`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getGetEventParticipantsQueryKey = (
  eventId: string,
  params?: GetEventParticipantsParams,
) => {
  return [
    `/api/events/${eventId}/participants`,
    ...(params ? [params] : []),
  ] as const
}

export const getGetEventParticipantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventParticipants>>,
  TError = AxiosError<HTTPValidationError>,
>(
  eventId: string,
  params?: GetEventParticipantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEventParticipants>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetEventParticipantsQueryKey(eventId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventParticipants>>
  > = ({ signal }) =>
    getEventParticipants(eventId, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!eventId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventParticipants>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetEventParticipantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventParticipants>>
>
export type GetEventParticipantsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Event Participants
 */
export const useGetEventParticipants = <
  TData = Awaited<ReturnType<typeof getEventParticipants>>,
  TError = AxiosError<HTTPValidationError>,
>(
  eventId: string,
  params?: GetEventParticipantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEventParticipants>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEventParticipantsQueryOptions(
    eventId,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Low Confidence Words
 */
export const getLowConfidenceWords = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AsrWord[]>> => {
  return axios.get(`/api/events/${id}/low-confidence-words`, options)
}

export const getGetLowConfidenceWordsQueryKey = (id: string) => {
  return [`/api/events/${id}/low-confidence-words`] as const
}

export const getGetLowConfidenceWordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLowConfidenceWords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLowConfidenceWords>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetLowConfidenceWordsQueryKey(id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLowConfidenceWords>>
  > = ({ signal }) => getLowConfidenceWords(id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLowConfidenceWords>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetLowConfidenceWordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLowConfidenceWords>>
>
export type GetLowConfidenceWordsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get Low Confidence Words
 */
export const useGetLowConfidenceWords = <
  TData = Awaited<ReturnType<typeof getLowConfidenceWords>>,
  TError = AxiosError<HTTPValidationError>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLowConfidenceWords>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLowConfidenceWordsQueryOptions(id, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Cr Not Joined
 */
export const crNotJoined = (
  id: string,
  crNotJoinedPayload: CrNotJoinedPayload,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/api/events/${id}/cr-not-joined`,
    crNotJoinedPayload,
    options,
  )
}

export const getCrNotJoinedMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crNotJoined>>,
    TError,
    { id: string; data: CrNotJoinedPayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof crNotJoined>>,
  TError,
  { id: string; data: CrNotJoinedPayload },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof crNotJoined>>,
    { id: string; data: CrNotJoinedPayload }
  > = props => {
    const { id, data } = props ?? {}

    return crNotJoined(id, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CrNotJoinedMutationResult = NonNullable<
  Awaited<ReturnType<typeof crNotJoined>>
>
export type CrNotJoinedMutationBody = CrNotJoinedPayload
export type CrNotJoinedMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Cr Not Joined
 */
export const useCrNotJoined = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof crNotJoined>>,
    TError,
    { id: string; data: CrNotJoinedPayload },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof crNotJoined>>,
  TError,
  { id: string; data: CrNotJoinedPayload },
  TContext
> => {
  const mutationOptions = getCrNotJoinedMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Book Event
 */
export const bookEvent = (
  id: string,
  bookPayload: BookPayload,
  params?: BookEventParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/api/events/${id}/booking`, bookPayload, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getBookEventMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bookEvent>>,
    TError,
    { id: string; data: BookPayload; params?: BookEventParams },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof bookEvent>>,
  TError,
  { id: string; data: BookPayload; params?: BookEventParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bookEvent>>,
    { id: string; data: BookPayload; params?: BookEventParams }
  > = props => {
    const { id, data, params } = props ?? {}

    return bookEvent(id, data, params, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type BookEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof bookEvent>>
>
export type BookEventMutationBody = BookPayload
export type BookEventMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Book Event
 */
export const useBookEvent = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bookEvent>>,
    TError,
    { id: string; data: BookPayload; params?: BookEventParams },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof bookEvent>>,
  TError,
  { id: string; data: BookPayload; params?: BookEventParams },
  TContext
> => {
  const mutationOptions = getBookEventMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Remove Event Booking
 */
export const removeEventBooking = (
  id: string,
  params?: RemoveEventBookingParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.delete(`/api/events/${id}/booking`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getRemoveEventBookingMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeEventBooking>>,
    TError,
    { id: string; params?: RemoveEventBookingParams },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeEventBooking>>,
  TError,
  { id: string; params?: RemoveEventBookingParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeEventBooking>>,
    { id: string; params?: RemoveEventBookingParams }
  > = props => {
    const { id, params } = props ?? {}

    return removeEventBooking(id, params, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RemoveEventBookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeEventBooking>>
>

export type RemoveEventBookingMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Remove Event Booking
 */
export const useRemoveEventBooking = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeEventBooking>>,
    TError,
    { id: string; params?: RemoveEventBookingParams },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof removeEventBooking>>,
  TError,
  { id: string; params?: RemoveEventBookingParams },
  TContext
> => {
  const mutationOptions = getRemoveEventBookingMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary End Event
 */
export const endEvent = (
  id: string,
  params?: EndEventParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/api/events/${id}/end`, undefined, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getEndEventMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endEvent>>,
    TError,
    { id: string; params?: EndEventParams },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof endEvent>>,
  TError,
  { id: string; params?: EndEventParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endEvent>>,
    { id: string; params?: EndEventParams }
  > = props => {
    const { id, params } = props ?? {}

    return endEvent(id, params, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type EndEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof endEvent>>
>

export type EndEventMutationError = AxiosError<HTTPValidationError>

/**
 * @summary End Event
 */
export const useEndEvent = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endEvent>>,
    TError,
    { id: string; params?: EndEventParams },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof endEvent>>,
  TError,
  { id: string; params?: EndEventParams },
  TContext
> => {
  const mutationOptions = getEndEventMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary List Availabilities
 */
export const listAvailabilities = (
  reporterId: string,
  params: ListAvailabilitiesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Availability[]>> => {
  return axios.get(`/api/reporters/${reporterId}/availabilities`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getListAvailabilitiesQueryKey = (
  reporterId: string,
  params: ListAvailabilitiesParams,
) => {
  return [
    `/api/reporters/${reporterId}/availabilities`,
    ...(params ? [params] : []),
  ] as const
}

export const getListAvailabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailabilities>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  params: ListAvailabilitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAvailabilities>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getListAvailabilitiesQueryKey(reporterId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAvailabilities>>
  > = ({ signal }) =>
    listAvailabilities(reporterId, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!reporterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAvailabilities>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListAvailabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailabilities>>
>
export type ListAvailabilitiesQueryError = AxiosError<HTTPValidationError>

/**
 * @summary List Availabilities
 */
export const useListAvailabilities = <
  TData = Awaited<ReturnType<typeof listAvailabilities>>,
  TError = AxiosError<HTTPValidationError>,
>(
  reporterId: string,
  params: ListAvailabilitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAvailabilities>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListAvailabilitiesQueryOptions(
    reporterId,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Availability
 */
export const createAvailability = (
  reporterId: string,
  createAvailability: CreateAvailability,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Availability>> => {
  return axios.post(
    `/api/reporters/${reporterId}/availabilities`,
    createAvailability,
    options,
  )
}

export const getCreateAvailabilityMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAvailability>>,
    TError,
    { reporterId: string; data: CreateAvailability },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAvailability>>,
  TError,
  { reporterId: string; data: CreateAvailability },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAvailability>>,
    { reporterId: string; data: CreateAvailability }
  > = props => {
    const { reporterId, data } = props ?? {}

    return createAvailability(reporterId, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAvailability>>
>
export type CreateAvailabilityMutationBody = CreateAvailability
export type CreateAvailabilityMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Create Availability
 */
export const useCreateAvailability = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAvailability>>,
    TError,
    { reporterId: string; data: CreateAvailability },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof createAvailability>>,
  TError,
  { reporterId: string; data: CreateAvailability },
  TContext
> => {
  const mutationOptions = getCreateAvailabilityMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Update Availability
 */
export const updateAvailability = (
  reporterId: string,
  availabilityId: string,
  updateAvailability: UpdateAvailability,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Availability>> => {
  return axios.patch(
    `/api/reporters/${reporterId}/availabilities/${availabilityId}`,
    updateAvailability,
    options,
  )
}

export const getUpdateAvailabilityMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAvailability>>,
    TError,
    { reporterId: string; availabilityId: string; data: UpdateAvailability },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAvailability>>,
  TError,
  { reporterId: string; availabilityId: string; data: UpdateAvailability },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAvailability>>,
    { reporterId: string; availabilityId: string; data: UpdateAvailability }
  > = props => {
    const { reporterId, availabilityId, data } = props ?? {}

    return updateAvailability(reporterId, availabilityId, data, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAvailability>>
>
export type UpdateAvailabilityMutationBody = UpdateAvailability
export type UpdateAvailabilityMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Update Availability
 */
export const useUpdateAvailability = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAvailability>>,
    TError,
    { reporterId: string; availabilityId: string; data: UpdateAvailability },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAvailability>>,
  TError,
  { reporterId: string; availabilityId: string; data: UpdateAvailability },
  TContext
> => {
  const mutationOptions = getUpdateAvailabilityMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Delete Availability
 */
export const deleteAvailability = (
  reporterId: string,
  availabilityId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.delete(
    `/api/reporters/${reporterId}/availabilities/${availabilityId}`,
    options,
  )
}

export const getDeleteAvailabilityMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAvailability>>,
    TError,
    { reporterId: string; availabilityId: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAvailability>>,
  TError,
  { reporterId: string; availabilityId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAvailability>>,
    { reporterId: string; availabilityId: string }
  > = props => {
    const { reporterId, availabilityId } = props ?? {}

    return deleteAvailability(reporterId, availabilityId, axiosOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAvailability>>
>

export type DeleteAvailabilityMutationError = AxiosError<HTTPValidationError>

/**
 * @summary Delete Availability
 */
export const useDeleteAvailability = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAvailability>>,
    TError,
    { reporterId: string; availabilityId: string },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAvailability>>,
  TError,
  { reporterId: string; availabilityId: string },
  TContext
> => {
  const mutationOptions = getDeleteAvailabilityMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Court Reporter Detail
 */
export const courtReporterDetail = (
  courtReporterId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporter>> => {
  return axios.get(`/api/court-reporters/${courtReporterId}`, options)
}

export const getCourtReporterDetailQueryKey = (courtReporterId: string) => {
  return [`/api/court-reporters/${courtReporterId}`] as const
}

export const getCourtReporterDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof courtReporterDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getCourtReporterDetailQueryKey(courtReporterId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof courtReporterDetail>>
  > = ({ signal }) =>
    courtReporterDetail(courtReporterId, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!courtReporterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof courtReporterDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CourtReporterDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof courtReporterDetail>>
>
export type CourtReporterDetailQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Court Reporter Detail
 */
export const useCourtReporterDetail = <
  TData = Awaited<ReturnType<typeof courtReporterDetail>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterDetail>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCourtReporterDetailQueryOptions(
    courtReporterId,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Court Reporter Events
 */
export const courtReporterEvents = (
  courtReporterId: string,
  params: CourtReporterEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CalendarCourtReporterEvent[]>> => {
  return axios.get(`/api/court-reporters/${courtReporterId}/events`, {
    ...options,
    params: { ...params, ...options?.params },
  })
}

export const getCourtReporterEventsQueryKey = (
  courtReporterId: string,
  params: CourtReporterEventsParams,
) => {
  return [
    `/api/court-reporters/${courtReporterId}/events`,
    ...(params ? [params] : []),
  ] as const
}

export const getCourtReporterEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof courtReporterEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  params: CourtReporterEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getCourtReporterEventsQueryKey(courtReporterId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof courtReporterEvents>>
  > = ({ signal }) =>
    courtReporterEvents(courtReporterId, params, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!courtReporterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof courtReporterEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CourtReporterEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courtReporterEvents>>
>
export type CourtReporterEventsQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Court Reporter Events
 */
export const useCourtReporterEvents = <
  TData = Awaited<ReturnType<typeof courtReporterEvents>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  params: CourtReporterEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEvents>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCourtReporterEventsQueryOptions(
    courtReporterId,
    params,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Court Reporter Event
 */
export const courtReporterEvent = (
  courtReporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterEventDetail>> => {
  return axios.get(
    `/api/court-reporters/${courtReporterId}/events/${id}`,
    options,
  )
}

export const getCourtReporterEventQueryKey = (
  courtReporterId: string,
  id: string,
) => {
  return [`/api/court-reporters/${courtReporterId}/events/${id}`] as const
}

export const getCourtReporterEventQueryOptions = <
  TData = Awaited<ReturnType<typeof courtReporterEvent>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEvent>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getCourtReporterEventQueryKey(courtReporterId, id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof courtReporterEvent>>
  > = ({ signal }) =>
    courtReporterEvent(courtReporterId, id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!(courtReporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof courtReporterEvent>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CourtReporterEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof courtReporterEvent>>
>
export type CourtReporterEventQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Court Reporter Event
 */
export const useCourtReporterEvent = <
  TData = Awaited<ReturnType<typeof courtReporterEvent>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEvent>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCourtReporterEventQueryOptions(
    courtReporterId,
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Court Reporter Event Join Info
 */
export const courtReporterEventJoinInfo = (
  courtReporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<JoinInfo>> => {
  return axios.get(
    `/api/court-reporters/${courtReporterId}/events/${id}/join-info`,
    options,
  )
}

export const getCourtReporterEventJoinInfoQueryKey = (
  courtReporterId: string,
  id: string,
) => {
  return [
    `/api/court-reporters/${courtReporterId}/events/${id}/join-info`,
  ] as const
}

export const getCourtReporterEventJoinInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof courtReporterEventJoinInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventJoinInfo>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getCourtReporterEventJoinInfoQueryKey(courtReporterId, id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof courtReporterEventJoinInfo>>
  > = ({ signal }) =>
    courtReporterEventJoinInfo(courtReporterId, id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!(courtReporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof courtReporterEventJoinInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CourtReporterEventJoinInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof courtReporterEventJoinInfo>>
>
export type CourtReporterEventJoinInfoQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Court Reporter Event Join Info
 */
export const useCourtReporterEventJoinInfo = <
  TData = Awaited<ReturnType<typeof courtReporterEventJoinInfo>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventJoinInfo>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCourtReporterEventJoinInfoQueryOptions(
    courtReporterId,
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Court Reporter Event Exhibits
 */
export const courtReporterEventExhibits = (
  courtReporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Exhibit[]>> => {
  return axios.get(
    `/api/court-reporters/${courtReporterId}/events/${id}/exhibits`,
    options,
  )
}

export const getCourtReporterEventExhibitsQueryKey = (
  courtReporterId: string,
  id: string,
) => {
  return [
    `/api/court-reporters/${courtReporterId}/events/${id}/exhibits`,
  ] as const
}

export const getCourtReporterEventExhibitsQueryOptions = <
  TData = Awaited<ReturnType<typeof courtReporterEventExhibits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventExhibits>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getCourtReporterEventExhibitsQueryKey(courtReporterId, id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof courtReporterEventExhibits>>
  > = ({ signal }) =>
    courtReporterEventExhibits(courtReporterId, id, { signal, ...axiosOptions })

  return {
    queryKey,
    queryFn,
    enabled: !!(courtReporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof courtReporterEventExhibits>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CourtReporterEventExhibitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courtReporterEventExhibits>>
>
export type CourtReporterEventExhibitsQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Court Reporter Event Exhibits
 */
export const useCourtReporterEventExhibits = <
  TData = Awaited<ReturnType<typeof courtReporterEventExhibits>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventExhibits>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCourtReporterEventExhibitsQueryOptions(
    courtReporterId,
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Court Reporter Event Media Resources
 */
export const courtReporterEventMediaResources = (
  courtReporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaResource[]>> => {
  return axios.get(
    `/api/court-reporters/${courtReporterId}/events/${id}/media-resources`,
    options,
  )
}

export const getCourtReporterEventMediaResourcesQueryKey = (
  courtReporterId: string,
  id: string,
) => {
  return [
    `/api/court-reporters/${courtReporterId}/events/${id}/media-resources`,
  ] as const
}

export const getCourtReporterEventMediaResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof courtReporterEventMediaResources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventMediaResources>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getCourtReporterEventMediaResourcesQueryKey(courtReporterId, id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof courtReporterEventMediaResources>>
  > = ({ signal }) =>
    courtReporterEventMediaResources(courtReporterId, id, {
      signal,
      ...axiosOptions,
    })

  return {
    queryKey,
    queryFn,
    enabled: !!(courtReporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof courtReporterEventMediaResources>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CourtReporterEventMediaResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof courtReporterEventMediaResources>>
>
export type CourtReporterEventMediaResourcesQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Court Reporter Event Media Resources
 */
export const useCourtReporterEventMediaResources = <
  TData = Awaited<ReturnType<typeof courtReporterEventMediaResources>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventMediaResources>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCourtReporterEventMediaResourcesQueryOptions(
    courtReporterId,
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Court Reporter Event Deliverables
 */
export const courtReporterEventDeliverables = (
  courtReporterId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterDeliverable[]>> => {
  return axios.get(
    `/api/court-reporters/${courtReporterId}/events/${id}/deliverables`,
    options,
  )
}

export const getCourtReporterEventDeliverablesQueryKey = (
  courtReporterId: string,
  id: string,
) => {
  return [
    `/api/court-reporters/${courtReporterId}/events/${id}/deliverables`,
  ] as const
}

export const getCourtReporterEventDeliverablesQueryOptions = <
  TData = Awaited<ReturnType<typeof courtReporterEventDeliverables>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventDeliverables>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getCourtReporterEventDeliverablesQueryKey(courtReporterId, id)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof courtReporterEventDeliverables>>
  > = ({ signal }) =>
    courtReporterEventDeliverables(courtReporterId, id, {
      signal,
      ...axiosOptions,
    })

  return {
    queryKey,
    queryFn,
    enabled: !!(courtReporterId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof courtReporterEventDeliverables>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type CourtReporterEventDeliverablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof courtReporterEventDeliverables>>
>
export type CourtReporterEventDeliverablesQueryError =
  AxiosError<HTTPValidationError>

/**
 * @summary Court Reporter Event Deliverables
 */
export const useCourtReporterEventDeliverables = <
  TData = Awaited<ReturnType<typeof courtReporterEventDeliverables>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courtReporterId: string,
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof courtReporterEventDeliverables>>,
      TError,
      TData
    >
    axios?: AxiosRequestConfig
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCourtReporterEventDeliverablesQueryOptions(
    courtReporterId,
    id,
    options,
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Save Court Reporter Event Deliverable
 */
export const saveCourtReporterEventDeliverable = (
  courtReporterId: string,
  id: string,
  saveCourtReporterDeliverablePayload: SaveCourtReporterDeliverablePayload,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterDeliverable>> => {
  return axios.post(
    `/api/court-reporters/${courtReporterId}/events/${id}/deliverables`,
    saveCourtReporterDeliverablePayload,
    options,
  )
}

export const getSaveCourtReporterEventDeliverableMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCourtReporterEventDeliverable>>,
    TError,
    {
      courtReporterId: string
      id: string
      data: SaveCourtReporterDeliverablePayload
    },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveCourtReporterEventDeliverable>>,
  TError,
  {
    courtReporterId: string
    id: string
    data: SaveCourtReporterDeliverablePayload
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveCourtReporterEventDeliverable>>,
    {
      courtReporterId: string
      id: string
      data: SaveCourtReporterDeliverablePayload
    }
  > = props => {
    const { courtReporterId, id, data } = props ?? {}

    return saveCourtReporterEventDeliverable(
      courtReporterId,
      id,
      data,
      axiosOptions,
    )
  }

  return { mutationFn, ...mutationOptions }
}

export type SaveCourtReporterEventDeliverableMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveCourtReporterEventDeliverable>>
>
export type SaveCourtReporterEventDeliverableMutationBody =
  SaveCourtReporterDeliverablePayload
export type SaveCourtReporterEventDeliverableMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Save Court Reporter Event Deliverable
 */
export const useSaveCourtReporterEventDeliverable = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCourtReporterEventDeliverable>>,
    TError,
    {
      courtReporterId: string
      id: string
      data: SaveCourtReporterDeliverablePayload
    },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof saveCourtReporterEventDeliverable>>,
  TError,
  {
    courtReporterId: string
    id: string
    data: SaveCourtReporterDeliverablePayload
  },
  TContext
> => {
  const mutationOptions =
    getSaveCourtReporterEventDeliverableMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Presign Court Reporter Event Deliverable
 */
export const presignCourtReporterEventDeliverable = (
  courtReporterId: string,
  id: string,
  presignCourtReporterDeliverablePayload: PresignCourtReporterDeliverablePayload,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CourtReporterDeliverableUploadUrl>> => {
  return axios.post(
    `/api/court-reporters/${courtReporterId}/events/${id}/deliverables/upload-url`,
    presignCourtReporterDeliverablePayload,
    options,
  )
}

export const getPresignCourtReporterEventDeliverableMutationOptions = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof presignCourtReporterEventDeliverable>>,
    TError,
    {
      courtReporterId: string
      id: string
      data: PresignCourtReporterDeliverablePayload
    },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationOptions<
  Awaited<ReturnType<typeof presignCourtReporterEventDeliverable>>,
  TError,
  {
    courtReporterId: string
    id: string
    data: PresignCourtReporterDeliverablePayload
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof presignCourtReporterEventDeliverable>>,
    {
      courtReporterId: string
      id: string
      data: PresignCourtReporterDeliverablePayload
    }
  > = props => {
    const { courtReporterId, id, data } = props ?? {}

    return presignCourtReporterEventDeliverable(
      courtReporterId,
      id,
      data,
      axiosOptions,
    )
  }

  return { mutationFn, ...mutationOptions }
}

export type PresignCourtReporterEventDeliverableMutationResult = NonNullable<
  Awaited<ReturnType<typeof presignCourtReporterEventDeliverable>>
>
export type PresignCourtReporterEventDeliverableMutationBody =
  PresignCourtReporterDeliverablePayload
export type PresignCourtReporterEventDeliverableMutationError =
  AxiosError<HTTPValidationError>

/**
 * @summary Presign Court Reporter Event Deliverable
 */
export const usePresignCourtReporterEventDeliverable = <
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof presignCourtReporterEventDeliverable>>,
    TError,
    {
      courtReporterId: string
      id: string
      data: PresignCourtReporterDeliverablePayload
    },
    TContext
  >
  axios?: AxiosRequestConfig
}): UseMutationResult<
  Awaited<ReturnType<typeof presignCourtReporterEventDeliverable>>,
  TError,
  {
    courtReporterId: string
    id: string
    data: PresignCourtReporterDeliverablePayload
  },
  TContext
> => {
  const mutationOptions =
    getPresignCourtReporterEventDeliverableMutationOptions(options)

  return useMutation(mutationOptions)
}
